/**
 * YG Pregnancy Checklist Builder
 * Used by sections/yg-pregnancy-checklist-builder.liquid.
 * Dependencies: DSM dialog/modal, Swiper 11, html2canvas, jsPDF,
 * and assets/yg-pregnancy-checklist-pdf.js.
 */
;(function () {
  if (!customElements.get('yg-pregnancy-checklist-builder')) {
    customElements.define(
      'yg-pregnancy-checklist-builder',
      class YGPregnancyChecklistBuilder extends HTMLElement {
        constructor() {
          super();
          this.onClick = this.onClick.bind(this);
          this.onChange = this.onChange.bind(this);
          this.onDrawerKeydown = this.onDrawerKeydown.bind(this);
          this.onPreviewKeydown = this.onPreviewKeydown.bind(this);
          this.onPreviewResize = this.onPreviewResize.bind(this);
          this.onStorage = this.onStorage.bind(this);
          this.onShareVisibilityChange = this.onShareVisibilityChange.bind(this);
          this.onSharePageHide = this.onSharePageHide.bind(this);
          this.onRelatedCartUpdated = this.onRelatedCartUpdated.bind(this);
          this.onRelatedQuickshopClosed = this.onRelatedQuickshopClosed.bind(this);
          this.onMobileBarVisibilityChange = this.onMobileBarVisibilityChange.bind(this);
          this.setupMobileBarVisibility = this.setupMobileBarVisibility.bind(this);
        }

        connectedCallback() {
          if (this.dataset.checklistBound) return;
          this.dataset.checklistBound = 'true';
          try {
            this.data = JSON.parse(this.querySelector('[data-pregnancy-checklist-data]').textContent);
          } catch (error) {
            return;
          }
          this.sortMomItems();
          this.copy = this.data.copy || {};
          this.selection = this.querySelector('[data-checklist-selection]');
          this.summary = this.querySelector('[data-checklist-summary]');
          this.countNodes = this.querySelectorAll('[data-checklist-count]');
          this.drawer = this.querySelector('[data-checklist-drawer]');
          this.drawerContent = this.querySelector('[data-checklist-drawer-content]');
          this.drawerTools = this.querySelector('[data-checklist-tools]');
          this.drawerOpenButton = this.querySelector('[data-checklist-drawer-open]');
          if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', this.setupMobileBarVisibility, { once: true });
          else this.setupMobileBarVisibility();
          this.preview = this.querySelector('[data-checklist-preview]');
          this.previewViewport = this.querySelector('[data-checklist-preview-viewport]');
          this.previewCanvas = this.querySelector('[data-checklist-preview-canvas]');
          this.previewPage = this.querySelector('[data-checklist-preview-page]');
          this.previewZoomNode = this.querySelector('[data-checklist-preview-zoom]');
          this.previewTitleNode = this.querySelector('[data-checklist-preview-title]');
          this.previewFullscreenButton = this.querySelector('[data-checklist-preview-fullscreen]');
          this.downloadNotice = this.querySelector('[data-checklist-download-notice]');
          this.downloadMessage = this.querySelector('[data-checklist-download-message]');
          this.downloadProgressNode = this.querySelector('[data-checklist-download-progress]');
          this.downloadCompactButton = this.querySelector('[data-checklist-download-notice-expand]');
          this.downloadSaveButton = this.querySelector('[data-checklist-download-save]');
          this.downloadRetryButton = this.querySelector('[data-checklist-download-retry]');
          this.downloadDismissButton = this.querySelector('[data-checklist-download-cancel]');
          this.downloadNoticeTimer = null;
          this.downloadNoticeCollapseTimer = null;
          this.downloadNoticeRevealTimer = null;
          this.downloadNoticeAutoHideDelay = 0;
          this.downloadProgress = 0;
          this.downloadJob = null;
          this.pendingPdfFile = null;
          this.isSavingPreparedPdf = false;
          this.isDownloadingPdf = false;
          this.isPrintingChecklist = false;
          this.canvasLibraryPromise = null;
          this.pdfDocumentLibraryPromise = null;
          this.pdfLibrariesPromise = null;
          this.pdfPreloadTimer = null;
          this.pdfPreloadTimerType = '';
          this.pdfPreparationDelayTimer = null;
          this.pdfPreparationIdleTimer = null;
          this.pdfPreparationPromise = null;
          this.pdfPreparationSignature = '';
          this.pdfPreparationVersion = 0;
          this.preparedPdfSource = null;
          this.preparedPdfSignature = '';
          this.preparedPdfExpiryTimer = null;
          this.pdfImageCache = new Map();
          this.pdfRenderedImageCache = new Map();
          this.pdfRenderedImageScale = null;
          this.pdfSelectionImagePreloadTimer = null;
          this.pdfWarmupDelayTimer = null;
          this.pdfWarmupIdleTimer = null;
          this.pdfWarmupPromise = null;
          this.pdfWarmupComplete = false;
          this.pdfWarmupDueAt = Date.now() + 10 * 1000;
          this.relatedContainer = this.querySelector('[data-checklist-related-products]');
          this.previewZoom = 1;
          this.previewFitActive = false;
          this.isPreviewPageFullscreen = false;
          this.dialogId = 'pregnancy-checklist-clear-' + this.dataset.sectionId;
          this.storageKey = 'momcozy:pregnancy-checklist:' + this.dataset.sectionId + ':v2';
          this.shareStorageKey = 'momcozy:pregnancy-checklist:share-id:v1';
          this.shareSnapshotStorageKey = 'momcozy:pregnancy-checklist:share-snapshot:v1';
          this.shareSyncPromise = null;
          this.shareSyncTimer = null;
          this.sharePrepareTimer = null;
          this.sharePrepareVersion = 0;
          this.isSharePreparing = false;
          this.isSharing = false;
          this.activeSharePlatform = '';
          this.relatedModule = this.data.relatedProducts || null;
          this.relatedProductMap = new Map();
          this.relatedProductLoading = new Set();
          this.relatedProductRemoving = new Set();
          this.relatedCart = { items: [], item_count: 0, total_price: 0 };
          this.relatedCartLoaded = false;
          this.relatedSwiper = null;
          this.relatedSwiperInitTimer = null;
          this.relatedQuickshopProduct = null;
          this.relatedQuickshopVariant = null;
          this.relatedQuickshopOptions = [];
          this.relatedQuickshopQuantity = 1;
          this.relatedQuickshopTrigger = null;
          this.relatedQuickshopDialogId = 'pregnancy-checklist-quickshop-' + this.dataset.sectionId;
          this.relatedQuickshopDialog = this.querySelector(
            '[data-dsm-dialog="' + this.relatedQuickshopDialogId + '"]'
          );
          this.relatedQuickshopContent = this.querySelector('[data-related-quickshop-content]');
          if (this.relatedQuickshopDialog) {
            this.relatedQuickshopDialog._dsmOnConfirm = () => this.submitRelatedQuickshop();
            this.relatedQuickshopDialog.addEventListener('dsm:dialog:close', this.onRelatedQuickshopClosed);
          }
          this.tab = 'mom';
          this.opened = {};
          this.drawerOpened = {};
          this.items = {};
          this.categories = {};
          this.selected = new Set();
          (this.data.mom || []).forEach((group, index) => {
            this.opened[group.key] = index === 0;
            this.categories[String(group.id)] = group;
            group.items.forEach((item) => {
              item.categoryId = String(group.id);
              item.checklistType = 'for_mom';
              this.items[item.id] = item;
            });
          });
          this.categories.for_baby = {
            id: 'for_baby',
            title: this.copy.forBaby || 'For Baby',
            items: this.data.baby || [],
          };
          (this.data.baby || []).forEach((item) => {
            item.categoryId = 'for_baby';
            item.checklistType = 'for_baby';
            this.items[item.id] = item;
          });
          this.refreshSelectionFromStorage(null, false);
          this.save();
          this.addEventListener('click', this.onClick);
          this.addEventListener('change', this.onChange);
          this.drawerOpenButton.addEventListener('click', () => this.openDrawer());
          this.drawer.addEventListener('click', (event) => {
            if (event.target.closest('[data-checklist-drawer-close]')) this.closeDrawer();
          });
          this.dialog = document.querySelector('[data-dsm-dialog="' + this.dialogId + '"]');
          if (this.dialog) this.dialog.addEventListener('dsm:dialog:confirm', () => this.clear());
          window.addEventListener('resize', this.onPreviewResize);
          window.addEventListener('storage', this.onStorage);
          document.addEventListener('visibilitychange', this.onShareVisibilityChange);
          window.addEventListener('pagehide', this.onSharePageHide);
          document.addEventListener('cart:updated', this.onRelatedCartUpdated);
          this.shareSyncTimer = window.setInterval(() => {
            if (document.visibilityState !== 'visible') return;
            this.syncExistingShare({ silent: true });
          }, 5 * 60 * 1000);
          this.render();
          this.schedulePdfWarmup(Math.max(0, this.pdfWarmupDueAt - Date.now()));
          this.emitChecklistEvent('YG:pregnancy-checklist-ready');
          if (this.relatedModule) this.loadRelatedCart();
        }

        sortMomItems() {
          (this.data.mom || []).forEach((group) => {
            group.items = (group.items || [])
              .map((item, index) => ({ item, index }))
              .sort((left, right) => {
                var leftOrder = Number(left.item.order);
                var rightOrder = Number(right.item.order);
                if (!Number.isFinite(leftOrder)) leftOrder = (left.index + 1) * 10;
                if (!Number.isFinite(rightOrder)) rightOrder = (right.index + 1) * 10;
                return leftOrder - rightOrder || left.index - right.index;
              })
              .map((entry) => entry.item);
          });
        }

        disconnectedCallback() {
          this.closeDrawer(true);
          this.closePreview(true);
          this.removeEventListener('click', this.onClick);
          this.removeEventListener('change', this.onChange);
          window.removeEventListener('resize', this.onPreviewResize);
          window.removeEventListener('storage', this.onStorage);
          document.removeEventListener('visibilitychange', this.onShareVisibilityChange);
          document.removeEventListener('DOMContentLoaded', this.setupMobileBarVisibility);
          window.removeEventListener('pagehide', this.onSharePageHide);
          document.removeEventListener('cart:updated', this.onRelatedCartUpdated);
          this.cancelScheduledPdfPreload();
          this.cancelScheduledPdfWarmup();
          this.cancelScheduledSelectedPdfImagesPreload();
          this.invalidatePreparedPdfSource();
          this.pdfImageCache.clear();
          this.releasePdfRenderedImageCache();
          if (this.downloadNoticeTimer) window.clearTimeout(this.downloadNoticeTimer);
          if (this.downloadNoticeCollapseTimer) window.clearTimeout(this.downloadNoticeCollapseTimer);
          if (this.downloadNoticeRevealTimer) window.clearTimeout(this.downloadNoticeRevealTimer);
          if (this.downloadJob) this.downloadJob.cancel();
          this.pendingPdfFile = null;
          if (this.mobileBarVisibilityObserver) this.mobileBarVisibilityObserver.disconnect();
          this.mobileBarVisibilityObserver = null;
          if (this.mobileBarVisibleStops) this.mobileBarVisibleStops.clear();
          if (this.relatedQuickshopDialog) {
            this.relatedQuickshopDialog._dsmOnConfirm = null;
            this.relatedQuickshopDialog.removeEventListener('dsm:dialog:close', this.onRelatedQuickshopClosed);
            if (this.relatedQuickshopDialog.classList.contains('is-open') && window.DsmDialog)
              window.DsmDialog.close(this.relatedQuickshopDialogId);
          }
          this.destroyRelatedSwiper();
          if (this.shareSyncTimer) window.clearInterval(this.shareSyncTimer);
          this.shareSyncTimer = null;
          if (this.sharePrepareTimer) window.clearTimeout(this.sharePrepareTimer);
          this.sharePrepareTimer = null;
          this.sharePrepareVersion += 1;
        }
        setupMobileBarVisibility() {
          if (!this.drawerOpenButton || typeof IntersectionObserver === 'undefined') return;
          var stopTargets = document.querySelectorAll('.shopify-section.yoga-ball-shop-car, #t4s-footer');
          if (!stopTargets.length) return;
          this.mobileBarVisibleStops = new Set();
          this.mobileBarVisibilityObserver = new IntersectionObserver(this.onMobileBarVisibilityChange, {
            threshold: 0,
          });
          stopTargets.forEach((target) => this.mobileBarVisibilityObserver.observe(target));
        }
        onMobileBarVisibilityChange(entries) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.mobileBarVisibleStops.add(entry.target);
            else this.mobileBarVisibleStops.delete(entry.target);
          });
          this.drawerOpenButton.classList.toggle('is-hidden', this.mobileBarVisibleStops.size > 0);
        }
        escape(value) {
          var div = document.createElement('div');
          div.textContent = String(value || '');
          return div.innerHTML;
        }
        text(key, values) {
          var output = String(this.copy[key] || '');
          Object.keys(values || {}).forEach((name) => {
            output = output.split('{' + name + '}').join(values[name]);
          });
          return output;
        }
        emitChecklistEvent(name) {
          this.dispatchEvent(
            new CustomEvent(name, {
              bubbles: true,
              detail: {
                builder: this,
                selectedIds: Array.from(this.selected),
              },
            })
          );
        }
        getChecklistItem(id) {
          return this.items[String(id || '').trim()] || null;
        }
        getChecklistCategory(categoryId) {
          return this.categories[String(categoryId || '').trim()] || null;
        }
        isChecklistItemSelected(id) {
          return this.selected.has(String(id || '').trim());
        }
        addChecklistItems(ids) {
          var sourceIds = Array.isArray(ids) ? ids : [ids];
          var changed = false;
          sourceIds.forEach((id) => {
            var normalizedId = String(id || '').trim();
            if (!this.items[normalizedId] || this.selected.has(normalizedId)) return;
            this.selected.add(normalizedId);
            changed = true;
          });
          if (!changed) return false;
          this.invalidatePreparedPdfSource();
          this.save();
          this.render();
          this.emitChecklistEvent('YG:pregnancy-checklist-change');
          return true;
        }
        save() {
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.selected)));
          } catch (error) {}
          this.scheduleShareChecklistSync();
        }
        storedSelection(rawValue) {
          try {
            var storedValue = rawValue;
            if (storedValue === null || typeof storedValue === 'undefined') {
              storedValue = localStorage.getItem(this.storageKey);
            }
            var storedIds = JSON.parse(storedValue || '[]');
            if (!Array.isArray(storedIds)) return [];
            return storedIds
              .map((id) => String(id))
              .filter((id, index, ids) => !!this.items[id] && ids.indexOf(id) === index);
          } catch (error) {
            return [];
          }
        }
        refreshSelectionFromStorage(rawValue, shouldRender) {
          var storedIds = this.storedSelection(rawValue);
          var hasChanged = storedIds.length !== this.selected.size || storedIds.some((id) => !this.selected.has(id));
          if (!hasChanged) return false;
          this.selected = new Set(storedIds);
          this.invalidatePreparedPdfSource();
          if (shouldRender) {
            this.render();
            this.emitChecklistEvent('YG:pregnancy-checklist-change');
          }
          return true;
        }
        onStorage(event) {
          if (event.key !== this.storageKey) return;
          if (this.refreshSelectionFromStorage(event.newValue, true)) this.scheduleShareChecklistSync();
        }
        relatedText(key, values) {
          var relatedCopy = (this.relatedModule && this.relatedModule.copy) || {};
          var output = String(relatedCopy[key] || '');
          Object.keys(values || {}).forEach((name) => {
            output = output.split('{' + name + '}').join(values[name]);
          });
          return output;
        }
        relatedEmphasisText(key, values, emphasisNames) {
          var tokens = {};
          var tokenValues = {};
          Object.keys(values || {}).forEach((name, index) => {
            var token = '__RELATED_VALUE_' + index + '__';
            tokens[name] = token;
            tokenValues[token] = values[name];
          });
          var output = this.escape(this.relatedText(key, tokens));
          Object.keys(tokenValues).forEach((token) => {
            var value = this.escape(tokenValues[token]);
            if ((emphasisNames || []).indexOf(Object.keys(tokens).find((name) => tokens[name] === token)) > -1)
              value = '<strong>' + value + '</strong>';
            output = output.split(token).join(value);
          });
          return output;
        }
        relatedDiscountTiers() {
          var discounts = (this.relatedModule && this.relatedModule.discounts) || {};
          return [2, 3, 4, 5].map((count) => ({
            count: count,
            discount: Math.min(100, Math.max(0, Number(discounts[String(count)]) || 0)),
          }));
        }
        relatedDiscountSummary() {
          var separator = (this.relatedText('discountSeparator') || ';').replace(/\s*$/, ' ');
          return this.relatedDiscountTiers()
            .filter((tier) => tier.discount > 0)
            .map((tier) => this.relatedText('discountTier', tier))
            .join(separator);
        }
        relatedProducts() {
          var products = new Map();
          var appendItemProducts = (item) => {
            if (!item || !this.selected.has(item.id)) return;
            (item && Array.isArray(item.products) ? item.products : []).forEach((product) => {
              var productId = String(product && product.id ? product.id : '');
              if (productId && !products.has(productId)) products.set(productId, product);
            });
          };
          (this.data.mom || []).forEach((group) => {
            (group.items || []).forEach(appendItemProducts);
          });
          (this.data.baby || []).forEach(appendItemProducts);
          this.relatedProductMap = products;
          return Array.from(products.values());
        }
        relatedProductVariantIds(product) {
          return new Set((product.variants || []).map((variant) => String(variant.id)));
        }
        isRelatedProductAdded(product) {
          var variantIds = this.relatedProductVariantIds(product);
          return (this.relatedCart.items || []).some((item) =>
            variantIds.has(String(item.variant_id || item.id || ''))
          );
        }
        relatedProductCartItems(product) {
          var variantIds = this.relatedProductVariantIds(product);
          return (this.relatedCart.items || []).filter((item) =>
            variantIds.has(String(item.variant_id || item.id || ''))
          );
        }
        relatedCartStats(products) {
          var variantIds = new Set();
          products.forEach((product) => {
            this.relatedProductVariantIds(product).forEach((variantId) => variantIds.add(variantId));
          });
          var quantity = 0;
          var discountItems = [];
          (this.relatedCart.items || []).forEach((item) => {
            if (!variantIds.has(String(item.variant_id || item.id || ''))) return;
            var itemQuantity = Math.max(0, Number(item.quantity) || 0);
            var unitPrice = Number(item.original_price);
            if (!Number.isFinite(unitPrice)) {
              var originalLinePrice = Number(item.original_line_price || item.line_price || 0);
              unitPrice = itemQuantity > 0 ? Math.round(originalLinePrice / itemQuantity) : 0;
            }
            quantity += itemQuantity;
            discountItems.push({ unitPrice: Math.max(0, unitPrice), quantity: itemQuantity });
          });
          return { quantity: quantity, discountItems: discountItems };
        }
        relatedTierSaving(discountItems, discount) {
          // Shopify percentage discounts allocated to each item are rounded to minor currency units per unit.
          return (discountItems || []).reduce((saving, item) => {
            var unitSaving = Math.floor((item.unitPrice * discount) / 100);
            return saving + unitSaving * item.quantity;
          }, 0);
        }
        formatRelatedMoney(cents) {
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: currency,
            }).format((Number(cents) || 0) / 100);
          } catch (error) {
            return '$' + ((Number(cents) || 0) / 100).toFixed(2);
          }
        }
        formatRelatedAmount(cents) {
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
          var amount = (Number(cents) || 0) / 100;
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: currency,
              currencyDisplay: 'narrowSymbol',
            }).format(amount);
          } catch (error) {
            return this.formatRelatedMoney(cents)
              .replace(/[A-Za-z]+/g, '')
              .trim();
          }
        }
        relatedMilestonesHtml(quantity) {
          var enabledTiers = this.relatedDiscountTiers().filter((tier) => tier.discount > 0);
          if (!enabledTiers.length) return '';
          var highestTierCount = enabledTiers[enabledTiers.length - 1].count;
          var currentCount = quantity > 0 ? Math.min(quantity, highestTierCount) : 0;
          var milestones = Array.from({ length: highestTierCount }, (_, index) => index + 1);
          return milestones
            .map((count, index) => {
              var isCurrent = currentCount === count;
              var isActive = quantity >= count;
              var milestoneContent = isCurrent
                ? '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5 10 3 3 7-7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg>'
                : this.escape(count);
              var track =
                index < milestones.length - 1
                  ? '<span class="yg-pregnancy-checklist-builder__milestone-track' +
                    (quantity >= milestones[index + 1] ? ' is-active' : '') +
                    '"></span>'
                  : '';
              return (
                '<span class="yg-pregnancy-checklist-builder__milestone' +
                (isActive ? ' is-active' : '') +
                (isCurrent ? ' is-current' : '') +
                '">' +
                milestoneContent +
                '</span>' +
                track
              );
            })
            .join('');
        }
        relatedProductActionHtml(product) {
          var productId = String(product.id);
          var variants = product.variants || [];
          var hasMultipleVariants = !product.hasOnlyDefaultVariant && variants.length > 1;
          var isAdded = this.isRelatedProductAdded(product);
          var isLoading = this.relatedProductLoading.has(productId);
          var isRemoving = this.relatedProductRemoving.has(productId);
          var isUnavailable = !product.available || !variants.some((variant) => variant.available);
          var isDisabled = isLoading || (!isAdded && isUnavailable);
          var label = isRemoving
            ? this.relatedText('removingProduct', { product: product.title })
            : isLoading
            ? this.relatedText('loadingProduct', { product: product.title })
            : isAdded
            ? this.relatedText('removeProduct', { product: product.title })
            : isUnavailable
            ? this.relatedText('soldOut')
            : hasMultipleVariants
            ? this.relatedText('selectVariant', { product: product.title })
            : this.relatedText('addProduct', { product: product.title });
          var icon = isLoading
            ? '<span class="yg-pregnancy-checklist-builder__loading-dots" aria-hidden="true"></span>'
            : isAdded
            ? '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5 10 3 3 7-7" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"/></svg>'
            : '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 5v10M5 10h10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5"/></svg>';
          return {
            disabled: isDisabled,
            loading: isLoading,
            added: isAdded,
            label: label,
            icon: icon,
          };
        }
        relatedProductCardHtml(product) {
          var action = this.relatedProductActionHtml(product);
          var variants = product.variants || [];
          var hasMultipleVariants = !product.hasOnlyDefaultVariant && variants.length > 1;
          var useQuickShop = hasMultipleVariants && !action.added && !action.disabled;
          var image = product.image
            ? '<img src="' + this.escape(product.image) + '" alt="' + this.escape(product.title) + '" loading="lazy">'
            : '';
          var openingTag = useQuickShop
            ? '<button type="button" class="yg-pregnancy-checklist-builder__product-card" data-related-quickshop-id="' +
              this.escape(product.id) +
              '" aria-haspopup="dialog" aria-controls="' +
              this.escape(this.relatedQuickshopDialogId + '-overlay') +
              '" aria-label="' +
              this.escape(action.label) +
              '">'
            : '<button type="button" class="yg-pregnancy-checklist-builder__product-card" data-related-product-id="' +
              this.escape(product.id) +
              '" aria-label="' +
              this.escape(action.label) +
              '"' +
              (action.disabled ? ' disabled aria-disabled="true"' : '') +
              (action.loading ? ' aria-busy="true"' : '') +
              '>';
          return (
            openingTag +
            '<span class="yg-pregnancy-checklist-builder__product-image">' +
            image +
            '</span><span class="yg-pregnancy-checklist-builder__product-details"><span class="yg-pregnancy-checklist-builder__product-title">' +
            this.escape(product.title) +
            '</span><span class="yg-pregnancy-checklist-builder__product-bottom"><span class="yg-pregnancy-checklist-builder__product-price">' +
            this.escape(product.priceFormatted || this.formatRelatedMoney(product.price)) +
            '</span><span class="yg-pregnancy-checklist-builder__product-action' +
            (action.added ? ' is-added' : '') +
            '">' +
            action.icon +
            '</span></span></span>' +
            '</button>'
          );
        }
        relatedEmptyHtml() {
          return (
            '<div class="yg-pregnancy-checklist-builder__related-empty"><div class="yg-pregnancy-checklist-builder__related-empty-copy"><p>' +
            this.escape(this.relatedText('noProductsTitle')) +
            '</p><p>' +
            this.escape(this.relatedText('noProductsDescription')) +
            '</p></div><button type="button" class="yg-pregnancy-checklist-builder__back-to-checklist" data-related-back-to-checklist><span>' +
            this.escape(this.relatedText('backToChecklist')) +
            '</span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 19V5M6 11l6-6 6 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></button></div>'
          );
        }
        renderRelatedProducts() {
          if (!this.relatedContainer || !this.relatedModule) return;
          var activeSlide = this.relatedSwiper ? this.relatedSwiper.activeIndex : 0;
          this.destroyRelatedSwiper();
          var products = this.relatedProducts();
          var discountSummary = this.relatedDiscountSummary();
          var heading =
            '<header class="yg-pregnancy-checklist-builder__related-heading"><h2>' +
            this.escape(this.relatedText('heading')) +
            '</h2>' +
            (discountSummary ? '<p>' + this.escape(discountSummary) + '</p>' : '') +
            '</header>';
          if (!products.length) {
            this.relatedContainer.innerHTML = heading + this.relatedEmptyHtml();
            return;
          }
          var stats = this.relatedCartStats(products);
          var enabledTiers = this.relatedDiscountTiers().filter((tier) => tier.discount > 0);
          var milestonesHtml = this.relatedMilestonesHtml(stats.quantity);
          var unlockedTier = enabledTiers.filter((tier) => stats.quantity >= tier.count).slice(-1)[0];
          var nextTier = enabledTiers.find((tier) => stats.quantity < tier.count);
          var unlockedLabel = unlockedTier
            ? '<span class="yg-pregnancy-checklist-builder__discount-unlocked">' +
              this.escape(this.relatedText('unlockedDiscount', unlockedTier)) +
              '</span>'
            : '';
          var detailHtml = '';
          if (unlockedTier) {
            var saving = this.relatedTierSaving(stats.discountItems, unlockedTier.discount);
            detailHtml =
              '<p>' +
              this.escape(this.relatedText('itemsInCart', { count: stats.quantity })) +
              '</p><p>' +
              this.relatedEmphasisText('totalSave', { amount: this.formatRelatedAmount(saving) }, ['amount']) +
              '</p>';
          } else {
            detailHtml = '<p>' + this.escape(this.relatedText('itemsInCart', { count: stats.quantity })) + '</p>';
            if (nextTier) {
              detailHtml +=
                '<p>' +
                this.relatedEmphasisText(
                  'unlockNext',
                  {
                    count: Math.max(0, nextTier.count - stats.quantity),
                    discount: nextTier.discount,
                  },
                  ['discount']
                ) +
                '</p>';
            }
          }
          var productCards = products
            .map((product) => '<div class="swiper-slide">' + this.relatedProductCardHtml(product) + '</div>')
            .join('');
          this.relatedContainer.innerHTML =
            heading +
            '<div class="yg-pregnancy-checklist-builder__related-panel"><div class="yg-pregnancy-checklist-builder__related-status">' +
            (milestonesHtml
              ? '<div class="yg-pregnancy-checklist-builder__milestone-row"><div class="yg-pregnancy-checklist-builder__milestones">' +
                milestonesHtml +
                '</div>' +
                unlockedLabel +
                '</div>'
              : '') +
            '<div class="yg-pregnancy-checklist-builder__cart-summary">' +
            detailHtml +
            '</div></div><span class="yg-pregnancy-checklist-builder__related-divider" aria-hidden="true"></span><div class="yg-pregnancy-checklist-builder__related-products"><div class="yg-pregnancy-checklist-builder__related-nav"><button type="button" class="yg-pregnancy-checklist-builder__related-prev" data-related-products-prev aria-label="' +
            this.escape(this.relatedText('previousProducts')) +
            '"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></button><button type="button" class="yg-pregnancy-checklist-builder__related-next" data-related-products-next aria-label="' +
            this.escape(this.relatedText('nextProducts')) +
            '"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="m15 6-6 6 6 6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg></button></div><div class="yg-pregnancy-checklist-builder__related-swiper swiper" data-related-products-swiper><div class="swiper-wrapper">' +
            productCards +
            '</div></div></div></div>';
          this.initRelatedSwiper(0, activeSlide);
        }
        initRelatedSwiper(attempt, initialSlide) {
          if (!this.relatedContainer || !this.isConnected) return;
          var swiperElement = this.relatedContainer.querySelector('[data-related-products-swiper]');
          if (!swiperElement) return;
          if (typeof window.Swiper !== 'function') {
            if ((attempt || 0) >= 40) return;
            this.relatedSwiperInitTimer = window.setTimeout(() => {
              this.relatedSwiperInitTimer = null;
              this.initRelatedSwiper((attempt || 0) + 1, initialSlide);
            }, 50);
            return;
          }
          var previousButton = this.relatedContainer.querySelector('[data-related-products-prev]');
          var nextButton = this.relatedContainer.querySelector('[data-related-products-next]');
          var maximumInitialSlide = Math.max(0, swiperElement.querySelectorAll('.swiper-slide').length - 1);
          this.relatedSwiper = new window.Swiper(swiperElement, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            initialSlide: Math.min(Math.max(0, Number(initialSlide) || 0), maximumInitialSlide),
            watchOverflow: true,
            preventClicks: false,
            preventClicksPropagation: false,
            touchStartPreventDefault: false,
            navigation: {
              prevEl: previousButton,
              nextEl: nextButton,
            },
            breakpoints: {
              1024: { spaceBetween: 16 },
            },
          });
        }
        destroyRelatedSwiper() {
          if (this.relatedSwiperInitTimer) {
            window.clearTimeout(this.relatedSwiperInitTimer);
            this.relatedSwiperInitTimer = null;
          }
          if (this.relatedSwiper && typeof this.relatedSwiper.destroy === 'function') {
            this.relatedSwiper.destroy(true, true);
          }
          this.relatedSwiper = null;
        }
        isRelatedColorOption(name) {
          var normalizedName = String(name || '').trim().toLowerCase();
          return normalizedName === 'color' || normalizedName === 'colour' || normalizedName === '颜色';
        }
        relatedQuickshopVariantByOptions(product, options) {
          return (product.variants || []).find(
            (variant) =>
              variant.available &&
              (variant.options || []).every((value, index) => String(value) === String(options[index]))
          );
        }
        relatedQuickshopSwatchImage(product, optionIndex, value) {
          var variants = product.variants || [];
          var matchingVariant = variants.find(
            (variant) =>
              variant.available && String((variant.options || [])[optionIndex]) === String(value) && variant.image
          );
          if (!matchingVariant)
            matchingVariant = variants.find(
              (variant) => String((variant.options || [])[optionIndex]) === String(value) && variant.image
            );
          return matchingVariant && matchingVariant.image ? matchingVariant.image : '';
        }
        relatedQuickshopOptionHtml(product, option, optionIndex) {
          var values = Array.isArray(option.values) ? option.values : [];
          var selectedValue = this.relatedQuickshopOptions[optionIndex] || '';
          var isColor = this.isRelatedColorOption(option.name);
          var optionLabel =
            '<div class="yg-pregnancy-checklist-builder__quickshop-option-label"><span>' +
            this.escape(option.name) +
            ' - ' +
            this.escape(selectedValue) +
            '</span>';
          var isSize = String(option.name || '').trim().toLowerCase() === 'size';
          if (isSize && product.sizeGuideUrl) {
            optionLabel +=
              '<a class="yg-pregnancy-checklist-builder__quickshop-guide" href="' +
              this.escape(product.sizeGuideUrl) +
              '" target="_blank" rel="nofollow noopener">' +
              this.escape(this.relatedText('sizeGuide')) +
              '</a>';
          }
          optionLabel += '</div>';
          var valueButtons = values
            .map((value) => {
              var available = (product.variants || []).some(
                (variant) =>
                  variant.available && String((variant.options || [])[optionIndex]) === String(value)
              );
              var selected = String(value) === String(selectedValue);
              var commonAttributes =
                ' type="button" data-related-quickshop-option data-related-quickshop-option-index="' +
                optionIndex +
                '" data-related-quickshop-option-value="' +
                this.escape(value) +
                '" aria-pressed="' +
                String(selected) +
                '"' +
                (available ? '' : ' disabled aria-disabled="true"');
              if (isColor) {
                var swatchImage = this.relatedQuickshopSwatchImage(product, optionIndex, value);
                return (
                  '<button class="yg-pregnancy-checklist-builder__quickshop-swatch"' +
                  commonAttributes +
                  ' aria-label="' +
                  this.escape(value) +
                  '" title="' +
                  this.escape(value) +
                  '">' +
                  (swatchImage
                    ? '<img src="' + this.escape(swatchImage) + '" alt="" loading="lazy">'
                    : '<span class="yg-pregnancy-checklist-builder__quickshop-swatch-text">' +
                      this.escape(value) +
                      '</span>') +
                  '</button>'
                );
              }
              return (
                '<button class="yg-pregnancy-checklist-builder__quickshop-value"' +
                commonAttributes +
                '>' +
                this.escape(value) +
                '</button>'
              );
            })
            .join('');
          var normalizedOptionName = String(option.name || '').trim().toLowerCase();
          var columns = Math.max(
            1,
            Math.min(isColor ? values.length : normalizedOptionName === 'style' ? 2 : 4, values.length)
          );
          return (
            '<div class="yg-pregnancy-checklist-builder__quickshop-option">' +
            optionLabel +
            '<div class="' +
            (isColor
              ? 'yg-pregnancy-checklist-builder__quickshop-swatches'
              : 'yg-pregnancy-checklist-builder__quickshop-values') +
            '" style="--quickshop-columns:' +
            columns +
            '">' +
            valueButtons +
            '</div></div>'
          );
        }
        renderRelatedQuickshop() {
          var product = this.relatedQuickshopProduct;
          if (!product || !this.relatedQuickshopContent) return;
          var variant = this.relatedQuickshopVariantByOptions(product, this.relatedQuickshopOptions);
          if (!variant) variant = (product.variants || []).find((item) => item.available);
          this.relatedQuickshopVariant = variant || null;
          if (variant) this.relatedQuickshopOptions = (variant.options || []).slice();
          var image = (variant && variant.image) || product.image || '';
          var compareAtPrice = variant && Number(variant.compareAtPrice) > Number(variant.price);
          var optionsHtml = (product.options || [])
            .map((option, optionIndex) => this.relatedQuickshopOptionHtml(product, option, optionIndex))
            .join('');
          this.relatedQuickshopContent.innerHTML =
            '<div class="yg-pregnancy-checklist-builder__quickshop-summary">' +
            (image
              ? '<img class="yg-pregnancy-checklist-builder__quickshop-image" src="' +
                this.escape(image) +
                '" alt="' +
                this.escape((variant && variant.imageAlt) || product.title) +
                '">'
              : '<span></span>') +
            '<div class="yg-pregnancy-checklist-builder__quickshop-summary-copy"><span class="yg-pregnancy-checklist-builder__quickshop-product-title">' +
            this.escape(product.title) +
            '</span><span class="yg-pregnancy-checklist-builder__quickshop-prices"><span class="yg-pregnancy-checklist-builder__quickshop-price">' +
            this.escape(variant ? variant.priceFormatted : product.priceFormatted) +
            '</span>' +
            (compareAtPrice
              ? '<span class="yg-pregnancy-checklist-builder__quickshop-compare-price">' +
                this.escape(variant.compareAtPriceFormatted) +
                '</span>'
              : '') +
            '</span></div><a class="yg-pregnancy-checklist-builder__quickshop-detail" href="' +
            this.escape(product.url || '#') +
            '">' +
            this.escape(this.relatedText('detail')) +
            '</a></div><div class="yg-pregnancy-checklist-builder__quickshop-options">' +
            optionsHtml +
            '</div><div class="yg-pregnancy-checklist-builder__quickshop-quantity-row"><span class="yg-pregnancy-checklist-builder__quickshop-quantity-label">' +
            this.escape(this.relatedText('quantity')) +
            '</span><div class="yg-pregnancy-checklist-builder__quickshop-stepper"><button type="button" class="yg-pregnancy-checklist-builder__quickshop-quantity-button" data-related-quickshop-quantity="decrease" aria-label="' +
            this.escape(this.relatedText('decreaseQuantity')) +
            '"' +
            (this.relatedQuickshopQuantity <= 1 ? ' disabled' : '') +
            '>−</button><span class="yg-pregnancy-checklist-builder__quickshop-quantity-value" aria-live="polite">' +
            this.relatedQuickshopQuantity +
            '</span><button type="button" class="yg-pregnancy-checklist-builder__quickshop-quantity-button" data-related-quickshop-quantity="increase" aria-label="' +
            this.escape(this.relatedText('increaseQuantity')) +
            '">+</button></div></div>';
          var addButton = this.relatedQuickshopDialog && this.relatedQuickshopDialog.querySelector('.js-dsm-dialog-confirm');
          if (addButton) {
            addButton.disabled = !variant;
            addButton.setAttribute('aria-disabled', String(!variant));
            var label = addButton.querySelector('.dsm-btn__label');
            if (label) label.textContent = variant ? this.relatedText('addToCart') : this.relatedText('soldOut');
          }
        }
        openRelatedQuickshop(product) {
          if (!product || !this.relatedQuickshopDialog || !window.DsmDialog) return;
          var variant =
            (product.variants || []).find(
              (item) => String(item.id) === String(product.defaultVariantId) && item.available
            ) || (product.variants || []).find((item) => item.available);
          if (!variant) return;
          this.relatedQuickshopProduct = product;
          this.relatedQuickshopVariant = variant;
          this.relatedQuickshopOptions = (variant.options || []).slice();
          this.relatedQuickshopQuantity = 1;
          this.renderRelatedQuickshop();
          this.relatedQuickshopTrigger = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          if (this.relatedQuickshopTrigger) this.relatedQuickshopTrigger.blur();
          window.DsmDialog.open(this.relatedQuickshopDialogId);
        }
        selectRelatedQuickshopOption(optionIndex, value) {
          var product = this.relatedQuickshopProduct;
          if (!product) return;
          var preferredOptions = this.relatedQuickshopOptions.slice();
          preferredOptions[optionIndex] = value;
          var variant = this.relatedQuickshopVariantByOptions(product, preferredOptions);
          if (!variant) {
            var candidates = (product.variants || []).filter(
              (item) => item.available && String((item.options || [])[optionIndex]) === String(value)
            );
            variant = candidates.sort((left, right) => {
              var score = (item) =>
                (item.options || []).reduce(
                  (total, optionValue, index) =>
                    total + (index !== optionIndex && String(optionValue) === String(this.relatedQuickshopOptions[index]) ? 1 : 0),
                  0
                );
              return score(right) - score(left);
            })[0];
          }
          if (!variant) return;
          this.relatedQuickshopVariant = variant;
          this.relatedQuickshopOptions = (variant.options || []).slice();
          this.renderRelatedQuickshop();
        }
        changeRelatedQuickshopQuantity(direction) {
          var delta = direction === 'increase' ? 1 : -1;
          this.relatedQuickshopQuantity = Math.max(1, Math.min(99, this.relatedQuickshopQuantity + delta));
          this.renderRelatedQuickshop();
        }
        submitRelatedQuickshop() {
          if (!this.relatedQuickshopProduct || !this.relatedQuickshopVariant)
            return Promise.reject(new Error('No available related-product variant selected.'));
          return this.addRelatedVariant(
            this.relatedQuickshopProduct,
            this.relatedQuickshopVariant,
            this.relatedQuickshopQuantity,
            true
          );
        }
        onRelatedQuickshopClosed() {
          var returnFocusTarget = this.relatedQuickshopTrigger;
          this.relatedQuickshopTrigger = null;
          this.relatedQuickshopProduct = null;
          this.relatedQuickshopVariant = null;
          this.relatedQuickshopOptions = [];
          this.relatedQuickshopQuantity = 1;
          if (this.relatedQuickshopContent) this.relatedQuickshopContent.innerHTML = '';
          if (returnFocusTarget && returnFocusTarget.isConnected) {
            window.requestAnimationFrame(() => {
              if (returnFocusTarget.isConnected) returnFocusTarget.focus({ preventScroll: true });
            });
          }
        }
        relatedCartRoot() {
          return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
        }
        async loadRelatedCart() {
          if (!this.relatedModule) return this.relatedCart;
          try {
            var response = await fetch(this.relatedCartRoot() + 'cart.js', {
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            });
            if (!response.ok) throw new Error('Cart request failed with status ' + response.status + '.');
            this.relatedCart = await response.json();
            this.relatedCartLoaded = true;
            this.renderRelatedProducts();
          } catch (error) {
            console.error('Unable to load checklist related-product cart state.', error);
          }
          return this.relatedCart;
        }
        onRelatedCartUpdated(event) {
          var cart = event && event.detail && event.detail.cart;
          if (cart && Array.isArray(cart.items)) {
            this.relatedCart = cart;
            this.relatedCartLoaded = true;
            this.renderRelatedProducts();
          } else if (this.relatedModule) this.loadRelatedCart();
        }
        updateRelatedHeaderCartCount(count) {
          document.querySelectorAll('[data-cart-count]').forEach((node) => {
            node.textContent = count;
            node.classList.toggle('t4s-op-0', count === 0);
          });
          document.querySelectorAll('.btn-groups__btn.tdf_cart_icon').forEach((cartIcon) => {
            var countNode = cartIcon.querySelector('[data-cart-count]');
            if (count > 0 && !countNode) {
              countNode = document.createElement('span');
              countNode.setAttribute('data-cart-count', '');
              countNode.className = 'count-box';
              cartIcon.appendChild(countNode);
            }
            if (!countNode) return;
            if (count > 0) countNode.textContent = count;
            else if (countNode.classList.contains('count-box')) countNode.remove();
          });
          document.documentElement.className = document.documentElement.className
            .replace(/\bt4s-cart-count-\d+\b/g, '')
            .trim();
          document.documentElement.classList.add('t4s-cart-count-' + count);
        }
        async addRelatedVariant(product, variant, quantity, rethrowError) {
          if (!product || !variant || !variant.available) return;
          var productId = String(product.id);
          if (this.relatedProductLoading.has(productId)) return;
          this.relatedProductLoading.add(productId);
          this.renderRelatedProducts();
          try {
            var formData = new FormData();
            formData.append('id', variant.id);
            formData.append('quantity', String(Math.max(1, Number(quantity) || 1)));
            formData.append('sections', 'mini-cart');
            formData.append('sections_url', window.location.pathname);
            var response = await fetch(this.relatedCartRoot() + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            var responseText = await response.text();
            var responseJson = JSON.parse(responseText);
            if (!response.ok) throw new Error(responseJson.description || 'Unable to add product to cart.');
            var cart = await this.loadRelatedCart();
            this.updateRelatedHeaderCartCount(cart.item_count || 0);
            this.dispatchEvent(
              new CustomEvent('variant:added', {
                bubbles: true,
                detail: { variant: responseJson.items ? responseJson.items[0] : responseJson },
              })
            );
            cart.sections = responseJson.sections;
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart, openMiniCart: false },
              })
            );
            return cart;
          } catch (error) {
            console.error('Unable to add checklist related product.', error);
            var message = this.relatedText('addError');
            if (message) window.alert(message);
            if (rethrowError) throw error;
          } finally {
            this.relatedProductLoading.delete(productId);
            this.renderRelatedProducts();
          }
        }
        async removeRelatedProduct(product) {
          if (!product) return;
          var productId = String(product.id);
          if (this.relatedProductLoading.has(productId)) return;
          var cartItems = this.relatedProductCartItems(product);
          if (!cartItems.length) return;
          var updates = {};
          cartItems.forEach((item) => {
            var lineIdentifier = item.key || item.variant_id || item.id;
            if (lineIdentifier) updates[String(lineIdentifier)] = 0;
          });
          if (!Object.keys(updates).length) return;
          this.relatedProductLoading.add(productId);
          this.relatedProductRemoving.add(productId);
          this.renderRelatedProducts();
          try {
            var response = await fetch(this.relatedCartRoot() + 'cart/update.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                updates: updates,
                sections: 'mini-cart',
                sections_url: window.location.pathname,
              }),
            });
            var responseText = await response.text();
            var cart = JSON.parse(responseText);
            if (!response.ok) throw new Error(cart.description || 'Unable to remove product from cart.');
            this.relatedCart = cart;
            this.relatedCartLoaded = true;
            this.updateRelatedHeaderCartCount(cart.item_count || 0);
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: { cart: cart, openMiniCart: false },
              })
            );
            return cart;
          } catch (error) {
            console.error('Unable to remove checklist related product.', error);
            var message = this.relatedText('removeError');
            if (message) window.alert(message);
          } finally {
            this.relatedProductLoading.delete(productId);
            this.relatedProductRemoving.delete(productId);
            this.renderRelatedProducts();
          }
        }
        shareChecklistData() {
          var momGroups = (this.data.mom || [])
            .map((group) => ({
              category_id: group.id,
              category_name: group.title,
              items: this.selectedItems(group.items).map((item) => ({ id: item.id, name: item.name })),
            }))
            .filter((group) => group.items.length);
          return {
            for_mom: momGroups,
            for_baby: {
              items: this.selectedItems(this.data.baby || []).map((item) => ({ id: item.id, name: item.name })),
            },
          };
        }
        storedShareId() {
          try {
            return String(localStorage.getItem(this.shareStorageKey) || '').trim();
          } catch (error) {
            return '';
          }
        }
        storeShareId(shareId) {
          try {
            localStorage.setItem(this.shareStorageKey, shareId);
          } catch (error) {}
        }
        storedShareSnapshot() {
          try {
            var snapshot = JSON.parse(localStorage.getItem(this.shareSnapshotStorageKey) || 'null');
            if (!snapshot || typeof snapshot !== 'object') return null;
            return {
              shareId: String(snapshot.shareId || '').trim(),
              checkListJson: String(snapshot.checkListJson || ''),
            };
          } catch (error) {
            return null;
          }
        }
        storeShareSnapshot(shareId, checkListJson) {
          this.storeShareId(shareId);
          try {
            localStorage.setItem(
              this.shareSnapshotStorageKey,
              JSON.stringify({ shareId: shareId, checkListJson: checkListJson })
            );
          } catch (error) {}
        }
        isShareSnapshotCurrent(shareId, checkListJson) {
          var snapshot = this.storedShareSnapshot();
          return !!snapshot && snapshot.shareId === shareId && snapshot.checkListJson === checkListJson;
        }
        shareApiUrl() {
          var apiBaseUrl = String(window.__MC__CONFIG__?.apiUrl || '').replace(/\/$/, '');
          return apiBaseUrl + this.data.shareApiUrl;
        }
        shareRequestHeaders() {
          return Object.assign({ 'Content-Type': 'application/json' }, window.__MC__CONFIG__?.headers || {});
        }
        async persistShareChecklist(checkListJson, currentShareId, options) {
          var requestBody = { checkListJson: checkListJson };
          if (currentShareId) requestBody.shareId = currentShareId;
          var response = await fetch(this.shareApiUrl(), {
            method: 'POST',
            headers: this.shareRequestHeaders(),
            body: JSON.stringify(requestBody),
            keepalive: !!(options && options.keepalive),
          });
          if (!response.ok) throw new Error('Checklist share request failed with status ' + response.status + '.');
          var result = await response.json().catch(() => ({}));
          var responseData = result && (result.result || result.data || result);
          var responseShareId = String(
            (responseData && (responseData.shareId || responseData.share_id)) ||
              (typeof responseData === 'string' ? responseData : '')
          ).trim();
          var shareId = responseShareId || currentShareId;
          if (!shareId) throw new Error('Checklist share response did not include a shareId.');
          this.storeShareSnapshot(shareId, checkListJson);
          return shareId;
        }
        async ensureShareChecklistSynced(options) {
          var syncOptions = options || {};
          var checkListJson = syncOptions.checkListJson || JSON.stringify(this.shareChecklistData());
          var currentShareId = this.storedShareId();
          if (!currentShareId && syncOptions.allowCreate === false) return '';
          if (currentShareId && this.isShareSnapshotCurrent(currentShareId, checkListJson)) {
            return currentShareId;
          }
          if (this.shareSyncPromise) {
            try {
              await this.shareSyncPromise;
            } catch (error) {}
            currentShareId = this.storedShareId();
            if (currentShareId && this.isShareSnapshotCurrent(currentShareId, checkListJson)) {
              return currentShareId;
            }
            if (!currentShareId && syncOptions.allowCreate === false) return '';
          }
          var syncPromise = this.persistShareChecklist(checkListJson, currentShareId, syncOptions);
          this.shareSyncPromise = syncPromise;
          try {
            return await syncPromise;
          } finally {
            if (this.shareSyncPromise === syncPromise) this.shareSyncPromise = null;
          }
        }
        syncExistingShare(options) {
          if (!this.storedShareId()) return Promise.resolve('');
          this.refreshSelectionFromStorage(null, document.visibilityState === 'visible');
          var syncOptions = Object.assign({ allowCreate: false }, options || {});
          return this.ensureShareChecklistSynced(syncOptions).catch((error) => {
            if (!syncOptions.silent) console.error('Pregnancy checklist background sync failed.', error);
            return '';
          });
        }
        scheduleShareChecklistSync() {
          // Prepare the share record before the tap so the Facebook share URL can open inside the user gesture.
          if (this.sharePrepareTimer) window.clearTimeout(this.sharePrepareTimer);
          this.sharePrepareTimer = null;
          this.sharePrepareVersion += 1;
          if (!this.selected.size || !this.data.shareDetailUrl) {
            this.isSharePreparing = false;
            this.syncShareButtons();
            return;
          }
          var checkListJson = JSON.stringify(this.shareChecklistData());
          var currentShareId = this.storedShareId();
          if (currentShareId && this.isShareSnapshotCurrent(currentShareId, checkListJson)) {
            this.isSharePreparing = false;
            this.syncShareButtons();
            return;
          }
          this.isSharePreparing = true;
          this.syncShareButtons();
          var prepareVersion = this.sharePrepareVersion;
          this.sharePrepareTimer = window.setTimeout(() => {
            this.sharePrepareTimer = null;
            this.ensureShareChecklistSynced({ allowCreate: true, checkListJson: checkListJson })
              .catch((error) => {
                console.error('Pregnancy checklist share preparation failed.', error);
                return '';
              })
              .finally(() => {
                if (prepareVersion !== this.sharePrepareVersion) return;
                this.isSharePreparing = false;
                this.syncShareButtons();
              });
          }, 150);
        }
        onShareVisibilityChange() {
          if (document.visibilityState === 'hidden') {
            this.cancelScheduledPdfPreparation();
            this.cancelScheduledPdfWarmup();
            this.cancelScheduledSelectedPdfImagesPreload();
            this.syncExistingShare({ keepalive: true, silent: true });
          } else {
            if (!this.pdfWarmupComplete)
              this.schedulePdfWarmup(Math.max(0, this.pdfWarmupDueAt - Date.now()));
            if (this.selected.size) this.scheduleSelectedPdfImagesPreload(800);
          }
        }
        onSharePageHide() {
          this.syncExistingShare({ keepalive: true, silent: true });
        }
        shareButtonHtml(platform) {
          var isFacebook = platform === 'facebook';
          var label = this.text(isFacebook ? 'shareFacebook' : 'shareX');
          var isDisabled = !this.selected.size || !this.data.shareDetailUrl;
          return (
            '<button type="button" class="yg-pregnancy-checklist-builder__social-button" data-checklist-share="' +
            platform +
            '" aria-label="' +
            this.escape(label) +
            '"' +
            (isDisabled ? ' disabled aria-disabled="true"' : '') +
            '>' +
            this.icon(isFacebook ? 'facebook' : 'x') +
            '</button>'
          );
        }
        syncShareButtons() {
          var canShare = !!this.selected.size && !!this.data.shareDetailUrl;
          this.querySelectorAll('[data-checklist-share]').forEach((button) => {
            var isActive = this.isSharing && button.getAttribute('data-checklist-share') === this.activeSharePlatform;
            var isDisabled = !canShare || this.isSharing || this.isSharePreparing;
            button.disabled = isDisabled;
            button.setAttribute('aria-disabled', String(isDisabled));
            button.setAttribute('aria-busy', String(isActive));
          });
        }
        encodeShareTargetUrl(detailUrl) {
          return encodeURIComponent(detailUrl);
        }
        shareDetailUrl(shareId) {
          var detailUrl = new URL(this.data.shareDetailUrl, window.location.href);
          detailUrl.searchParams.set('share_id', shareId);
          return detailUrl.toString();
        }
        shareIntentUrl(platform, detailUrl) {
          var encodedDetailUrl = this.encodeShareTargetUrl(detailUrl);
          if (platform === 'facebook') {
            return 'https://www.facebook.com/sharer/sharer.php?u=' + encodedDetailUrl;
          }
          return 'https://twitter.com/intent/tweet?url=' + encodedDetailUrl;
        }
        isMobileShareDevice() {
          return (
            /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
          );
        }
        canUseNativeShare() {
          return this.isMobileShareDevice() && typeof navigator.share === 'function';
        }
        async openShareTarget(platform, detailUrl, pendingWindow) {
          if (this.canUseNativeShare()) {
            try {
              await navigator.share({
                title: this.copy.summaryTitle || document.title || 'My Hospital Bag Checklist',
                url: detailUrl,
              });
              if (pendingWindow && !pendingWindow.closed) pendingWindow.close();
              return;
            } catch (error) {
              if (error && error.name === 'AbortError') {
                if (pendingWindow && !pendingWindow.closed) pendingWindow.close();
                return;
              }
              console.warn('Native checklist sharing failed; falling back to the platform share page.', error);
            }
          }
          var shareUrl = this.shareIntentUrl(platform, detailUrl);
          if (pendingWindow && !pendingWindow.closed) {
            pendingWindow.location.replace(shareUrl);
            return;
          }
          var shareTab = window.open(shareUrl, '_blank');
          if (shareTab) shareTab.opener = null;
        }
        async shareChecklist(platform) {
          if (
            this.isSharing ||
            this.isSharePreparing ||
            !this.selected.size ||
            !this.data.shareDetailUrl ||
            (platform !== 'facebook' && platform !== 'x')
          )
            return;
          this.isSharing = true;
          this.activeSharePlatform = platform;
          this.syncShareButtons();
          var pendingWindow = null;
          try {
            var checkListJson = JSON.stringify(this.shareChecklistData());
            var shareId = this.storedShareId();
            var isPrepared = !!shareId && this.isShareSnapshotCurrent(shareId, checkListJson);
            if (!isPrepared && !this.canUseNativeShare()) {
              pendingWindow = window.open('', '_blank');
              if (pendingWindow) pendingWindow.opener = null;
            }
            if (!isPrepared) {
              shareId = await this.ensureShareChecklistSynced({
                allowCreate: true,
                checkListJson: checkListJson,
              });
            }
            var detailUrl = this.shareDetailUrl(shareId);
            await this.openShareTarget(platform, detailUrl, pendingWindow);
          } catch (error) {
            if (pendingWindow && !pendingWindow.closed) pendingWindow.close();
            console.error('Pregnancy checklist sharing failed.', error);
            var errorMessage = this.text('shareError');
            if (errorMessage) window.alert(errorMessage);
          } finally {
            this.isSharing = false;
            this.activeSharePlatform = '';
            this.syncShareButtons();
          }
        }
        icon(type) {
          var icons = {
            mom: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M14.5232 1.9564C15.097 1.81792 15.6997 1.85681 16.2509 2.06789C16.8021 2.279 17.2763 2.65259 17.6108 3.13886C17.9453 3.62524 18.1244 4.20221 18.1243 4.7925C18.1242 5.39651 17.9065 5.97316 17.6368 6.45266C17.5444 6.61696 17.4419 6.77433 17.3357 6.92385C17.7208 7.03748 18.0734 7.24971 18.3538 7.54641C18.7714 7.98844 18.996 8.57915 18.9788 9.18703C18.9615 9.79364 18.7038 10.3679 18.2635 10.7853L18.2643 10.7862L14.4427 14.4401C13.7262 15.241 12.7243 15.6258 11.666 15.6258H8.33264C7.96508 15.6258 7.76418 15.7452 7.66613 15.8757C7.64008 15.9104 7.61009 15.9431 7.57743 15.9717L6.74653 16.6976L7.10786 17.0589C7.35189 17.303 7.35191 17.6987 7.10786 17.9427C6.8638 18.1868 6.46815 18.1868 6.22407 17.9427L1.22407 12.9427C0.979996 12.6987 0.979996 12.303 1.22407 12.0589C1.46815 11.8149 1.86379 11.8149 2.10786 12.0589L2.50663 12.4577L6.70666 8.40823C7.10989 7.90991 7.72114 7.70917 8.33264 7.70917H9.99442L9.97407 7.68882C9.37107 7.08577 8.5411 6.05661 8.54097 4.7925C8.54089 4.20221 8.71999 3.62524 9.05448 3.13886C9.38896 2.65262 9.86321 2.27899 10.4143 2.06789C10.9656 1.85683 11.5683 1.8179 12.142 1.9564C12.5819 2.06262 12.9889 2.27003 13.3326 2.55862C13.6764 2.27006 14.0834 2.06261 14.5232 1.9564ZM16.7164 8.07945C16.4399 8.07163 16.1713 8.17345 15.9702 8.36347C15.9572 8.37575 15.9432 8.38669 15.9295 8.39765L12.4668 11.617C12.4435 11.6387 12.4182 11.6574 12.3927 11.6748C11.9693 12.0695 11.4135 12.2925 10.8326 12.2925H9.16597C8.82079 12.2925 8.54097 12.0127 8.54097 11.6675C8.54098 11.3223 8.8208 11.0425 9.16597 11.0425H10.8326C11.1089 11.0425 11.3738 10.9327 11.5691 10.7373C11.7644 10.542 11.8743 10.2771 11.8743 10.0008C11.8743 9.72459 11.7645 9.45969 11.5691 9.26435C11.3738 9.06901 11.1089 8.95919 10.8326 8.95917H8.33264C7.965 8.95917 7.76415 9.07849 7.66613 9.20901C7.64613 9.23568 7.6234 9.26073 7.5994 9.28388L3.39123 13.3423L5.8603 15.8114L6.71398 15.0659C7.11728 14.5743 7.72486 14.3758 8.33264 14.3758H11.666C12.4281 14.3758 13.0802 14.1022 13.5288 13.5897L13.567 13.549L17.4008 9.88284L17.4033 9.88039C17.6043 9.69042 17.7217 9.4277 17.7296 9.15123C17.7374 8.87478 17.6347 8.60601 17.4448 8.40497C17.2548 8.20413 16.9928 8.08732 16.7164 8.07945ZM15.8033 3.23489C15.4884 3.1144 15.1439 3.09229 14.8162 3.17141C14.4886 3.25056 14.1926 3.42762 13.9674 3.67841L13.9617 3.68492C13.8817 3.77175 13.7842 3.84091 13.6761 3.88837C13.5678 3.93582 13.4508 3.96079 13.3326 3.9608C13.2144 3.9608 13.0974 3.93582 12.9892 3.88837C12.8811 3.84092 12.7836 3.77179 12.7036 3.68492L12.6979 3.67841C12.4727 3.42759 12.1767 3.25057 11.8491 3.17141C11.5213 3.09227 11.1768 3.11442 10.8619 3.23489C10.547 3.3555 10.2759 3.56981 10.0848 3.84768C9.89375 4.12546 9.79102 4.45459 9.79097 4.79169C9.7911 5.52564 10.2958 6.24211 10.8546 6.80178L13.3318 9.10484L15.809 6.80178C16.0653 6.54507 16.3405 6.20716 16.5472 5.83987C16.7572 5.46636 16.8742 5.10483 16.8743 4.7925C16.8742 4.4554 16.7715 4.12546 16.5805 3.84768C16.3894 3.56978 16.1183 3.35551 15.8033 3.23489Z" fill="black"/></svg>',
            baby: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M9.98438 1.05469C11.0271 1.05469 11.9808 1.34128 12.6927 1.85384C13.4081 2.36893 13.902 3.13716 13.902 4.05111C13.902 5.57636 12.8949 7.04671 11.367 7.04671C10.8931 7.04669 10.4128 6.93 10.0283 6.68538C9.63943 6.43791 9.29266 6.01369 9.29264 5.43376C9.29264 5.05194 9.60256 4.74204 9.98438 4.74202C10.3662 4.74202 10.6761 5.05193 10.6761 5.43376L10.6785 5.43783C10.6866 5.4504 10.7118 5.48103 10.7705 5.51839C10.8929 5.59629 11.1037 5.66404 11.367 5.66406C11.8671 5.66406 12.5193 5.10682 12.5194 4.05111C12.5194 3.6745 12.3215 3.29063 11.8846 2.97607C11.4443 2.65908 10.7852 2.43815 9.98438 2.43815C8.23459 2.44201 6.53967 3.04885 5.18538 4.1569C3.83074 5.26525 2.89953 6.80721 2.54948 8.52214C2.5063 8.73307 2.3673 8.91167 2.1735 9.00553C1.97873 9.09989 1.81481 9.24777 1.69987 9.43115C1.58496 9.61454 1.52409 9.82672 1.52409 10.0431C1.52415 10.2595 1.58496 10.4718 1.69987 10.6551C1.78604 10.7925 1.8999 10.9096 2.03353 10.9993L2.1735 11.0799L2.24268 11.1182C2.39834 11.2169 2.50949 11.3745 2.54867 11.5568C2.91344 13.2581 3.85014 14.7834 5.20329 15.8773C6.55653 16.9711 8.24432 17.5675 9.98438 17.5675C11.7244 17.5675 13.4122 16.9711 14.7655 15.8773C16.1186 14.7834 17.0553 13.2581 17.4201 11.5568C17.4648 11.3486 17.6036 11.1727 17.7952 11.0799C17.9899 10.9856 18.154 10.8383 18.2689 10.6551C18.3838 10.4718 18.4454 10.2595 18.4455 10.0431C18.4455 9.8267 18.3838 9.61455 18.2689 9.43115C18.1539 9.24775 17.99 9.09989 17.7952 9.00553C17.5992 8.91057 17.4591 8.72869 17.4176 8.51481C17.184 7.30978 16.6621 6.17928 15.8966 5.21973C15.6586 4.92132 15.7074 4.4862 16.0057 4.24805C16.3041 4.00999 16.7392 4.05882 16.9774 4.3571C17.8158 5.40806 18.4065 6.63295 18.7083 7.94027C19.0015 8.13765 19.2516 8.39459 19.4408 8.69629C19.6937 9.09979 19.8281 9.56691 19.8281 10.0431C19.8281 10.5192 19.6936 10.9857 19.4408 11.3892C19.2499 11.6936 18.9968 11.952 18.7002 12.1501C18.2264 14.0382 17.1529 15.725 15.6346 16.9523C14.0353 18.2451 12.0408 18.9502 9.98438 18.9502C7.92794 18.9502 5.93344 18.245 4.33415 16.9523C2.81584 15.7249 1.74152 14.0383 1.26774 12.1501C0.971399 11.952 0.718679 11.6934 0.527995 11.3892C0.275137 10.9857 0.140684 10.5192 0.140625 10.0431C0.140625 9.56691 0.275081 9.0998 0.527995 8.69629C0.718044 8.39312 0.969447 8.13478 1.26449 7.93701C1.72307 6.03425 2.79047 4.32981 4.30973 3.08675C5.91062 1.77694 7.91432 1.05892 9.98275 1.05469H9.98438Z" fill="black"/><path d="M7.54785 13.374C7.74437 13.0468 8.16941 12.9408 8.49674 13.1372C8.83705 13.3413 9.35606 13.4993 9.98438 13.4993C10.6127 13.4993 11.1317 13.3413 11.472 13.1372C11.7993 12.9408 12.2244 13.0468 12.4209 13.374C12.6173 13.7014 12.5113 14.1264 12.1841 14.3229C11.6026 14.6718 10.8308 14.882 9.98438 14.882C9.13791 14.882 8.36618 14.6718 7.78467 14.3229C7.45749 14.1264 7.35146 13.7013 7.54785 13.374Z" fill="black"/><path d="M7.22803 9.3514C7.60986 9.3514 7.91976 9.6613 7.91976 10.0431C7.91959 10.4248 7.60975 10.734 7.22803 10.734H7.21908C6.83735 10.734 6.52751 10.4248 6.52734 10.0431C6.52734 9.6613 6.83724 9.3514 7.21908 9.3514H7.22803Z" fill="black"/><path d="M12.7594 9.3514C13.1411 9.35159 13.4504 9.66142 13.4504 10.0431C13.4502 10.4247 13.141 10.7339 12.7594 10.734H12.7497C12.368 10.7339 12.0589 10.4248 12.0588 10.0431C12.0588 9.66137 12.3679 9.35151 12.7497 9.3514H12.7594Z" fill="black"/></svg>',
            preview:
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M2.25 10C4.15 6.65 6.78 5 10 5C13.22 5 15.85 6.65 17.75 10C15.85 13.35 13.22 15 10 15C6.78 15 4.15 13.35 2.25 10Z" stroke="#1A1A1A" stroke-width="1.5" stroke-linejoin="round"/><path d="M9.99961 12.4016C11.3251 12.4016 12.3996 11.327 12.3996 10.0016C12.3996 8.67608 11.3251 7.60156 9.99961 7.60156C8.67413 7.60156 7.59961 8.67608 7.59961 10.0016C7.59961 11.327 8.67413 12.4016 9.99961 12.4016Z" stroke="#1A1A1A" stroke-width="1.5"/></svg>',
            download:
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M10 2V13M14 9L10 13L6 9M3 16.5H17" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            print:
              '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M5 7V2.5H15V7M5 14H3.5C2.7 14 2 13.3 2 12.5V8.5C2 7.7 2.7 7 3.5 7H16.5C17.3 7 18 7.7 18 8.5V12.5C18 13.3 17.3 14 16.5 14H15M5 11H15V17.5H5V11Z" stroke="#1A1A1A" stroke-width="1.5" stroke-linejoin="round"/></svg>',
            facebook:
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" data-checklist-social-icon><path d="M11.4758 8.88387L11.8904 6.15378H9.2968V4.3829C9.2968 3.63582 9.65845 2.90718 10.8201 2.90718H12V0.582904C12 0.582904 10.9297 0.398438 9.90685 0.398438C7.76986 0.398438 6.37443 1.7063 6.37443 4.073V6.15378H4V8.88387H6.37443V15.4841C6.85114 15.5597 7.33881 15.5984 7.83562 15.5984C8.33242 15.5984 8.82009 15.5597 9.2968 15.4841V8.88387H11.4758Z" fill="black"/></svg>',
            x: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" data-checklist-social-icon><path d="M12.2169 1.26953H14.4659L9.55249 6.88519L15.3327 14.5268H10.8068L7.26204 9.89222L3.20598 14.5268H0.955637L6.21097 8.52026L0.666016 1.26953H5.30676L8.51095 5.50575L12.2169 1.26953ZM11.4276 13.1807H12.6737L4.62961 2.54495H3.29232L11.4276 13.1807Z" fill="#1A1A1A"/></svg>',
            close:
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"><path d="m6 6 12 12M18 6 6 18"/></svg>',
            check:
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"><path d="m5 12 4 4 10-10"/></svg>',
            chevron:
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.7"><path d="m6 15 6-6 6 6"/></svg>',
          };
          return icons[type] || '';
        }
        toolsHtml() {
          var isDisabled = !this.selected.size;
          var disabled = isDisabled ? ' disabled aria-disabled="true"' : '';
          var shareDisabled = isDisabled || !this.data.shareDetailUrl;
          var shareState = shareDisabled ? ' is-disabled' : '';
          return (
            '<button type="button" class="yg-pregnancy-checklist-builder__tool" data-checklist-preview-open aria-haspopup="dialog"' +
            disabled +
            '>' +
            this.icon('preview') +
            this.escape(this.text('preview')) +
            '</button><button type="button" class="yg-pregnancy-checklist-builder__tool" data-checklist-download' +
            disabled +
            '>' +
            this.icon('download') +
            this.escape(this.text('download')) +
            '</button><button type="button" class="yg-pregnancy-checklist-builder__tool" data-checklist-print' +
            disabled +
            '>' +
            this.icon('print') +
            this.escape(this.text('print')) +
            '</button><span class="yg-pregnancy-checklist-builder__tool' +
            shareState +
            '" aria-disabled="' +
            shareDisabled +
            '">' +
            '<span>' +
            this.escape(this.text('share')) +
            '</span>' +
            this.shareButtonHtml('facebook') +
            this.shareButtonHtml('x') +
            '</span>'
          );
        }
        selectedItems(items) {
          return items.filter((item) => this.selected.has(item.id));
        }
        itemRows(items) {
          return items
            .map(
              (item) =>
                '<div class="yg-pregnancy-checklist-builder__selected-item"><span>' +
                this.escape(item.name) +
                '</span><button class="yg-pregnancy-checklist-builder__remove" type="button" data-checklist-remove="' +
                this.escape(item.id) +
                '" aria-label="' +
                this.escape(this.text('remove', { item: item.name })) +
                '">' +
                this.icon('close') +
                '</button></div>'
            )
            .join('');
        }
        setHtmlPreservingImages(container, html) {
          if (!container) return;
          var currentImages = new Map();
          container.querySelectorAll('img[data-checklist-image-key]').forEach((image) => {
            var key = image.getAttribute('data-checklist-image-key');
            if (key) currentImages.set(key, image);
          });
          var template = document.createElement('template');
          template.innerHTML = html;
          template.content.querySelectorAll('img[data-checklist-image-key]').forEach((image) => {
            var key = image.getAttribute('data-checklist-image-key');
            var currentImage = currentImages.get(key);
            if (!currentImage || currentImage.getAttribute('src') !== image.getAttribute('src')) return;
            image.replaceWith(currentImage);
          });
          container.replaceChildren(template.content);
        }
        selectedHtml(options) {
          var isDrawer = !!(options && options.drawer);
          var momGroups = (this.data.mom || [])
            .map((group) => ({ group: group, items: this.selectedItems(group.items) }))
            .filter((entry) => entry.items.length);
          var babyItems = this.selectedItems(this.data.baby || []);
          if (!momGroups.length && !babyItems.length)
            return (
              '<div class="yg-pregnancy-checklist-builder__empty">' + this.escape(this.text('emptyMessage')) + '</div>'
            );
          var html = '';
          if (momGroups.length) {
            html +=
              '<div class="yg-pregnancy-checklist-builder__summary-group"><p class="yg-pregnancy-checklist-builder__group-label">' +
              this.icon('mom') +
              this.escape(this.text('forMom')) +
              '</p><div class="yg-pregnancy-checklist-builder__cards">';
            momGroups.forEach((entry, index) => {
              var hasImage = !!entry.group.image;
              var drawerKey = String(entry.group.key);
              var image = hasImage
                ? '<img data-checklist-image-key="category:' +
                  this.escape(drawerKey) +
                  '" src="' +
                  this.escape(entry.group.image) +
                  '" alt="">'
                : '';
              if (isDrawer && !Object.prototype.hasOwnProperty.call(this.drawerOpened, drawerKey))
                this.drawerOpened[drawerKey] = index === 0;
              var isOpen = isDrawer ? !!this.drawerOpened[drawerKey] : true;
              var panelId = 'checklist-drawer-card-' + this.dataset.sectionId + '-' + index;
              var cardHead =
                (isDrawer ? '<button type="button"' : '<div') +
                ' class="yg-pregnancy-checklist-builder__card-head' +
                (hasImage ? ' has-image' : '') +
                '"' +
                (isDrawer
                  ? ' data-checklist-drawer-card="' +
                    this.escape(drawerKey) +
                    '" aria-expanded="' +
                    isOpen +
                    '" aria-controls="' +
                    this.escape(panelId) +
                    '"'
                  : '') +
                '>' +
                image +
                '<span class="yg-pregnancy-checklist-builder__card-label"><span>' +
                this.escape(entry.group.title) +
                (isDrawer ? ' (' + entry.items.length + ')' : '') +
                '</span>' +
                (isDrawer
                  ? '<span class="yg-pregnancy-checklist-builder__card-chevron" aria-hidden="true">' +
                    this.icon('chevron') +
                    '</span>'
                  : '') +
                '</span>' +
                (isDrawer ? '</button>' : '</div>');
              var selectedRows = this.itemRows(entry.items);
              html +=
                '<div class="yg-pregnancy-checklist-builder__card">' +
                cardHead +
                (isDrawer
                  ? '<div class="yg-pregnancy-checklist-builder__card-list-collapse" id="' +
                    this.escape(panelId) +
                    '" aria-hidden="' +
                    !isOpen +
                    '"' +
                    (isOpen ? '' : ' hidden') +
                    '><div class="yg-pregnancy-checklist-builder__selected-list yg-pregnancy-checklist-builder__card-list">' +
                    selectedRows +
                    '</div></div>'
                  : '<div class="yg-pregnancy-checklist-builder__selected-list">' + selectedRows + '</div>') +
                '</div>';
            });
            html += '</div></div>';
          }
          if (babyItems.length)
            html +=
              '<div class="yg-pregnancy-checklist-builder__summary-group"><p class="yg-pregnancy-checklist-builder__group-label">' +
              this.icon('baby') +
              this.escape(this.text('forBaby')) +
              '</p><div class="yg-pregnancy-checklist-builder__baby-card"><div class="yg-pregnancy-checklist-builder__selected-list">' +
              this.itemRows(babyItems) +
              '</div></div></div>';
          return html;
        }
        previewItemsHtml(items) {
          return items
            .map(
              (item) =>
                '<div class="yg-pregnancy-checklist-builder__preview-document-item"><span class="yg-pregnancy-checklist-builder__preview-document-checkbox" aria-hidden="true"></span><span>' +
                this.escape(item.name) +
                '</span></div>'
            )
            .join('');
        }
        previewHtml(options) {
          var isWarmup = !!(options && options.warmup);
          var momGroups = (this.data.mom || [])
            .map((group) => ({ group: group, items: isWarmup ? [] : this.selectedItems(group.items) }))
            .filter((entry) => isWarmup || entry.items.length);
          var babyItems = isWarmup ? [] : this.selectedItems(this.data.baby || []);
          var countText = this.escape(this.text('selectedCount', { count: isWarmup ? 0 : this.selected.size }));
          var hasImage = !!this.data.desktopSummaryImage;
          var image = hasImage
            ? '<img data-checklist-image-key="preview-summary-header" src="' +
              this.escape(this.data.desktopSummaryImage) +
              '" alt="">'
            : '';
          var previewLogo = this.data.previewLogo
            ? '<img class="yg-pregnancy-checklist-builder__preview-document-logo" data-checklist-image-key="preview-logo" src="' +
              this.escape(this.data.previewLogo) +
              '" alt="">'
            : '';
          var html =
            '<div class="yg-pregnancy-checklist-builder__preview-document-head' +
            (hasImage ? ' has-image' : '') +
            '">' +
            image +
            '<div class="yg-pregnancy-checklist-builder__preview-document-heading">' +
            previewLogo +
            '<h3>' +
            this.escape(this.text('summaryTitle')) +
            '</h3></div></div><div class="yg-pregnancy-checklist-builder__preview-document-body"><p class="yg-pregnancy-checklist-builder__preview-document-count">' +
            countText +
            '</p>';
          if (!momGroups.length && !babyItems.length) {
            return (
              html +
              '<div class="yg-pregnancy-checklist-builder__preview-document-empty">' +
              this.escape(this.text('emptyMessage')) +
              '</div></div>'
            );
          }
          if (momGroups.length) {
            html +=
              '<section class="yg-pregnancy-checklist-builder__preview-document-group"><h4>' +
              this.icon('mom') +
              this.escape(this.text('forMom')) +
              '</h4><div class="yg-pregnancy-checklist-builder__preview-document-cards">';
            momGroups.forEach((entry) => {
              var hasCategoryImage = !!entry.group.image;
              var categoryImage = hasCategoryImage
                ? '<img data-checklist-image-key="preview-category:' +
                  this.escape(String(entry.group.key)) +
                  '" src="' +
                  this.escape(entry.group.image) +
                  '" alt="">'
                : '';
              html +=
                '<div class="yg-pregnancy-checklist-builder__preview-document-card"><div class="yg-pregnancy-checklist-builder__preview-document-card-head' +
                (hasCategoryImage ? ' has-image' : '') +
                '">' +
                categoryImage +
                '<span>' +
                this.escape(entry.group.title) +
                '</span></div><div class="yg-pregnancy-checklist-builder__preview-document-items">' +
                this.previewItemsHtml(entry.items) +
                '</div></div>';
            });
            html += '</div></section>';
          }
          if (babyItems.length) {
            html +=
              '<section class="yg-pregnancy-checklist-builder__preview-document-group yg-pregnancy-checklist-builder__preview-document-baby"><h4>' +
              this.icon('baby') +
              this.escape(this.text('forBaby')) +
              '</h4><div class="yg-pregnancy-checklist-builder__preview-document-card"><div class="yg-pregnancy-checklist-builder__preview-document-items">' +
              this.previewItemsHtml(babyItems) +
              '</div></div></section>';
          }
          return html + '</div>';
        }
        renderPreview() {
          if (!this.previewPage) return;
          if (this.previewTitleNode)
            this.previewTitleNode.textContent =
              this.text('previewTitle') + ' • ' + this.text('previewSelectedCount', { count: this.selected.size });
          this.setHtmlPreservingImages(this.previewPage, this.previewHtml());
          window.requestAnimationFrame(() => this.syncPreviewCanvas());
        }
        syncPreviewCanvas() {
          if (!this.previewPage || !this.previewCanvas) return;
          var width = this.previewPage.offsetWidth;
          var height = this.previewPage.offsetHeight;
          this.previewCanvas.style.width = Math.ceil(width * this.previewZoom) + 'px';
          this.previewCanvas.style.height = Math.ceil(height * this.previewZoom) + 'px';
          this.previewPage.style.transform = 'scale(' + this.previewZoom + ')';
          if (this.previewZoomNode) this.previewZoomNode.textContent = Math.round(this.previewZoom * 100) + '%';
        }
        setPreviewZoom(zoom) {
          this.previewFitActive = false;
          this.previewZoom = Math.max(0.25, Math.min(2, zoom));
          this.syncPreviewCanvas();
        }
        fitPreview() {
          if (!this.previewViewport || !this.previewPage) return;
          var availableWidth = this.previewViewport.clientWidth - 72;
          var availableHeight = this.previewViewport.clientHeight - 72;
          var width = this.previewPage.offsetWidth;
          var height = this.previewPage.offsetHeight;
          if (!width || !height) return;
          this.previewFitActive = true;
          this.previewZoom = Math.max(0.25, Math.min(2, Math.min(availableWidth / width, availableHeight / height)));
          this.syncPreviewCanvas();
        }
        fitMobilePreview() {
          if (!this.previewViewport || !this.previewPage) return;
          var availableWidth = this.previewViewport.clientWidth - 40;
          var width = this.previewPage.offsetWidth;
          if (!width) return;
          this.previewFitActive = true;
          this.previewZoom = Math.max(0.25, Math.min(2, availableWidth / width));
          this.syncPreviewCanvas();
        }
        syncPreviewFullscreenButton() {
          if (!this.previewFullscreenButton) return;
          this.previewFullscreenButton.setAttribute('aria-pressed', String(this.isPreviewPageFullscreen));
          this.previewFullscreenButton.setAttribute(
            'aria-label',
            this.text(this.isPreviewPageFullscreen ? 'previewExitFullscreen' : 'previewFullscreen')
          );
        }
        togglePreviewFullscreen() {
          if (!this.preview || !matchMedia('(max-width: 767px)').matches) return;
          this.isPreviewPageFullscreen = !this.isPreviewPageFullscreen;
          this.preview.classList.toggle('is-page-fullscreen', this.isPreviewPageFullscreen);
          this.syncPreviewFullscreenButton();
          window.requestAnimationFrame(() => {
            if (this.isPreviewPageFullscreen) {
              this.previewFitActive = false;
              this.previewZoom = 1;
              this.syncPreviewCanvas();
            } else {
              this.fitMobilePreview();
            }
          });
        }
        cancelScheduledPdfPreload() {
          if (!this.pdfPreloadTimer) return;
          if (this.pdfPreloadTimerType === 'idle' && typeof window.cancelIdleCallback === 'function')
            window.cancelIdleCallback(this.pdfPreloadTimer);
          else window.clearTimeout(this.pdfPreloadTimer);
          this.pdfPreloadTimer = null;
          this.pdfPreloadTimerType = '';
        }
        schedulePdfLibrariesPreload() {
          var isMobile = matchMedia('(max-width: 767px)').matches;
          if ((isMobile ? this.pdfDocumentLibraryPromise : this.pdfLibrariesPromise) || this.pdfPreloadTimer) return;
          var preload = () => {
            this.pdfPreloadTimer = null;
            this.pdfPreloadTimerType = '';
            this.preloadPdfLibraries();
          };
          if (typeof window.requestIdleCallback === 'function') {
            this.pdfPreloadTimerType = 'idle';
            this.pdfPreloadTimer = window.requestIdleCallback(preload, { timeout: 2000 });
          } else {
            this.pdfPreloadTimerType = 'timeout';
            this.pdfPreloadTimer = window.setTimeout(preload, 800);
          }
        }
        preloadPdfLibraries() {
          this.cancelScheduledPdfPreload();
          var libraryPromise = matchMedia('(max-width: 767px)').matches
            ? this.loadPdfDocumentLibrary()
            : this.loadPdfLibraries();
          libraryPromise.catch(() => {});
        }
        normalizePdfImageUrl(url) {
          if (!url) return '';
          try {
            return new URL(url, window.location.href).href;
          } catch (error) {
            return String(url);
          }
        }
        pdfStaticImageUrls() {
          var urls = [this.data.desktopSummaryImage, this.data.previewLogo];
          (this.data.mom || []).forEach((group) => {
            if (group.image) urls.push(group.image);
          });
          return urls
            .map((url) => this.normalizePdfImageUrl(url))
            .filter((url, index, values) => !!url && values.indexOf(url) === index);
        }
        selectedPdfImageUrls() {
          var urls = [this.data.desktopSummaryImage, this.data.previewLogo];
          (this.data.mom || []).forEach((group) => {
            if (group.image && group.items.some((item) => this.selected.has(item.id))) urls.push(group.image);
          });
          return urls
            .map((url) => this.normalizePdfImageUrl(url))
            .filter((url, index, values) => !!url && values.indexOf(url) === index);
        }
        cancelScheduledSelectedPdfImagesPreload() {
          if (this.pdfSelectionImagePreloadTimer)
            window.clearTimeout(this.pdfSelectionImagePreloadTimer);
          this.pdfSelectionImagePreloadTimer = null;
        }
        scheduleSelectedPdfImagesPreload(delay) {
          this.cancelScheduledSelectedPdfImagesPreload();
          if (!this.selected.size) return;
          this.pdfSelectionImagePreloadTimer = window.setTimeout(() => {
            this.pdfSelectionImagePreloadTimer = null;
            if (!this.isConnected || document.visibilityState === 'hidden') return;
            this.preloadPdfImages(this.selectedPdfImageUrls()).catch(() => {});
          }, Math.max(0, delay || 0));
        }
        loadPdfImage(url) {
          url = this.normalizePdfImageUrl(url);
          if (!url) return Promise.resolve(null);
          if (this.pdfImageCache.has(url)) return this.pdfImageCache.get(url).promise;
          var image = new Image();
          image.crossOrigin = 'anonymous';
          image.decoding = 'async';
          var promise = new Promise((resolve, reject) => {
            var finish = () => {
              image.removeEventListener('load', finish);
              image.removeEventListener('error', fail);
              var decoded = typeof image.decode === 'function' ? image.decode().catch(() => {}) : Promise.resolve();
              decoded.then(() => resolve(image));
            };
            var fail = () => {
              image.removeEventListener('load', finish);
              image.removeEventListener('error', fail);
              this.pdfImageCache.delete(url);
              reject(new Error('A checklist PDF image failed to load.'));
            };
            image.addEventListener('load', finish, { once: true });
            image.addEventListener('error', fail, { once: true });
            image.src = url;
            if (image.complete) {
              if (image.naturalWidth) finish();
              else fail();
            }
          });
          this.pdfImageCache.set(url, { image: image, promise: promise });
          return promise;
        }
        preloadPdfImages(urls) {
          return Promise.all((urls || []).map((url) => this.loadPdfImage(url)));
        }
        async preloadPdfImagesWithProgress(urls, job, progressStart, progressEnd) {
          var uniqueUrls = (urls || [])
            .map((url) => this.normalizePdfImageUrl(url))
            .filter((url, index, values) => !!url && values.indexOf(url) === index);
          if (!uniqueUrls.length) {
            this.setDownloadProgress(progressEnd);
            return [];
          }
          var completed = 0;
          return Promise.all(
            uniqueUrls.map(async (url) => {
              var image = await this.waitForDownloadTask(this.loadPdfImage(url), job);
              completed += 1;
              this.setDownloadProgress(
                progressStart + ((progressEnd - progressStart) * completed) / uniqueUrls.length
              );
              return image;
            })
          );
        }
        releasePdfRenderedImageCache() {
          this.pdfRenderedImageCache.forEach((canvas) => this.releaseCanvas(canvas));
          this.pdfRenderedImageCache.clear();
          this.pdfRenderedImageScale = null;
        }
        pdfImagePositionRatio(objectPosition, axis) {
          var value = String(objectPosition || '').toLowerCase();
          var tokens = value.trim().split(/\s+/);
          var token = tokens[axis === 'x' ? 0 : 1] || '50%';
          if (axis === 'x') {
            if (token === 'left') return 0;
            if (token === 'right') return 1;
          } else {
            if (token === 'top') return 0;
            if (token === 'bottom') return 1;
          }
          if (token === 'center') return 0.5;
          if (/%$/.test(token)) return Math.max(0, Math.min(1, Number.parseFloat(token) / 100));
          return 0.5;
        }
        cachedPdfImageCanvas(imageNode, width, height, computedStyle) {
          var url = this.normalizePdfImageUrl(imageNode.currentSrc || imageNode.src);
          var cachedImage = this.pdfImageCache.get(url);
          if (!cachedImage || !cachedImage.image || !cachedImage.image.naturalWidth) return null;
          var renderScale = this.pdfRenderScale();
          if (this.pdfRenderedImageScale !== null && this.pdfRenderedImageScale !== renderScale)
            this.releasePdfRenderedImageCache();
          this.pdfRenderedImageScale = renderScale;
          var cacheKey =
            url +
            '|' +
            Math.round(width * 100) +
            'x' +
            Math.round(height * 100) +
            '|' +
            computedStyle.objectFit +
            '|' +
            computedStyle.objectPosition +
            '|' +
            renderScale;
          if (this.pdfRenderedImageCache.has(cacheKey)) return this.pdfRenderedImageCache.get(cacheKey);
          var sourceImage = cachedImage.image;
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.ceil(width * renderScale));
          canvas.height = Math.max(1, Math.ceil(height * renderScale));
          var context = canvas.getContext('2d');
          if (!context) return null;
          var outputWidth = canvas.width;
          var outputHeight = canvas.height;
          var sourceWidth = sourceImage.naturalWidth;
          var sourceHeight = sourceImage.naturalHeight;
          var fit = computedStyle.objectFit || 'fill';
          var drawWidth = outputWidth;
          var drawHeight = outputHeight;
          if (fit === 'cover' || fit === 'contain') {
            var scale =
              fit === 'cover'
                ? Math.max(outputWidth / sourceWidth, outputHeight / sourceHeight)
                : Math.min(outputWidth / sourceWidth, outputHeight / sourceHeight);
            drawWidth = sourceWidth * scale;
            drawHeight = sourceHeight * scale;
          }
          var drawX =
            (outputWidth - drawWidth) * this.pdfImagePositionRatio(computedStyle.objectPosition, 'x');
          var drawY =
            (outputHeight - drawHeight) * this.pdfImagePositionRatio(computedStyle.objectPosition, 'y');
          context.drawImage(sourceImage, drawX, drawY, drawWidth, drawHeight);
          this.pdfRenderedImageCache.set(cacheKey, canvas);
          return canvas;
        }
        primePdfRenderedImages(container) {
          Array.prototype.slice.call(container.querySelectorAll('img')).forEach((imageNode) => {
            var rect = imageNode.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            this.cachedPdfImageCanvas(imageNode, rect.width, rect.height, window.getComputedStyle(imageNode));
          });
        }
        replacePdfImagesWithCachedCanvases(container) {
          Array.prototype.slice.call(container.querySelectorAll('img')).forEach((imageNode) => {
            var rect = imageNode.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            var computedStyle = window.getComputedStyle(imageNode);
            var cachedCanvas = this.cachedPdfImageCanvas(imageNode, rect.width, rect.height, computedStyle);
            if (!cachedCanvas) return;
            var canvas = document.createElement('canvas');
            canvas.width = cachedCanvas.width;
            canvas.height = cachedCanvas.height;
            var context = canvas.getContext('2d');
            if (!context) return;
            context.drawImage(cachedCanvas, 0, 0);
            canvas.className = imageNode.className;
            canvas.setAttribute('aria-hidden', 'true');
            var imageKey = imageNode.getAttribute('data-checklist-image-key');
            if (imageKey) canvas.setAttribute('data-checklist-image-key', imageKey);
            canvas.style.position = computedStyle.position;
            canvas.style.top = computedStyle.top;
            canvas.style.right = computedStyle.right;
            canvas.style.bottom = computedStyle.bottom;
            canvas.style.left = computedStyle.left;
            canvas.style.zIndex = computedStyle.zIndex;
            canvas.style.display = computedStyle.display;
            canvas.style.width = rect.width + 'px';
            canvas.style.height = rect.height + 'px';
            canvas.style.margin = computedStyle.margin;
            imageNode.replaceWith(canvas);
          });
        }
        pdfWarmupHtml() {
          return this.previewHtml({ warmup: true });
        }
        cancelScheduledPdfWarmup() {
          if (this.pdfWarmupDelayTimer) window.clearTimeout(this.pdfWarmupDelayTimer);
          this.pdfWarmupDelayTimer = null;
          if (this.pdfWarmupIdleTimer) {
            if (typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(this.pdfWarmupIdleTimer);
            else window.clearTimeout(this.pdfWarmupIdleTimer);
          }
          this.pdfWarmupIdleTimer = null;
        }
        schedulePdfWarmup(delay) {
          if (
            this.pdfWarmupComplete ||
            this.pdfWarmupPromise ||
            this.pdfWarmupDelayTimer ||
            this.pdfWarmupIdleTimer
          )
            return;
          var startWhenIdle = () => {
            this.pdfWarmupDelayTimer = null;
            var warmup = () => {
              this.pdfWarmupIdleTimer = null;
              if (!this.isConnected || document.visibilityState === 'hidden') return;
              var warmupPromise = this.warmPdfRenderer();
              this.pdfWarmupPromise = warmupPromise;
              warmupPromise
                .then(() => {
                  this.pdfWarmupComplete = true;
                })
                .catch(() => {})
                .finally(() => {
                  if (this.pdfWarmupPromise === warmupPromise) this.pdfWarmupPromise = null;
                });
            };
            if (typeof window.requestIdleCallback === 'function')
              this.pdfWarmupIdleTimer = window.requestIdleCallback(warmup, { timeout: 3000 });
            else this.pdfWarmupIdleTimer = window.setTimeout(warmup, 0);
          };
          this.pdfWarmupDelayTimer = window.setTimeout(startWhenIdle, Math.max(0, delay || 0));
        }
        async warmPdfRenderer() {
          var isMobile = matchMedia('(max-width: 767px)').matches;
          var capture = document.createElement('article');
          capture.className =
            'yg-pregnancy-checklist-builder__preview-page yg-pregnancy-checklist-builder__pdf-capture';
          capture.innerHTML = this.pdfWarmupHtml();
          document.body.appendChild(capture);
          try {
            if (isMobile) await this.loadPdfDocumentLibrary();
            else await this.loadPdfLibraries();
            if (document.fonts && document.fonts.ready) await document.fonts.ready;
            await this.preloadPdfImages(this.pdfStaticImageUrls());
            await this.waitForPreviewImages(capture);
            // This only crops and scales the reusable static images. It does not
            // capture the full checklist or block interactions like html2canvas.
            this.primePdfRenderedImages(capture);
          } finally {
            capture.remove();
          }
        }
        pdfRenderScale() {
          // A 1.5x A4 capture is still roughly 160 DPI at this layout width, while
          // using about 44% less canvas memory than 2x on memory-constrained phones.
          return matchMedia('(max-width: 767px)').matches ? 1.5 : 2;
        }
        pdfSelectionSignature() {
          return Array.from(this.selected).sort().join('\u001f') + '|scale:' + this.pdfRenderScale();
        }
        cancelScheduledPdfPreparation() {
          if (this.pdfPreparationDelayTimer) window.clearTimeout(this.pdfPreparationDelayTimer);
          this.pdfPreparationDelayTimer = null;
          if (this.pdfPreparationIdleTimer) {
            if (typeof window.cancelIdleCallback === 'function')
              window.cancelIdleCallback(this.pdfPreparationIdleTimer);
            else window.clearTimeout(this.pdfPreparationIdleTimer);
          }
          this.pdfPreparationIdleTimer = null;
        }
        releasePreparedPdfSource() {
          if (this.preparedPdfExpiryTimer) window.clearTimeout(this.preparedPdfExpiryTimer);
          this.preparedPdfExpiryTimer = null;
          if (this.preparedPdfSource) this.releaseCanvas(this.preparedPdfSource.canvas);
          this.preparedPdfSource = null;
          this.preparedPdfSignature = '';
        }
        invalidatePreparedPdfSource() {
          this.pdfPreparationVersion += 1;
          this.cancelScheduledPdfPreparation();
          this.releasePreparedPdfSource();
        }
        cachePreparedPdfSource(source, signature) {
          this.releasePreparedPdfSource();
          this.preparedPdfSource = source;
          this.preparedPdfSignature = signature;
          // A rendered mobile canvas can retain tens of MB. Keep it only long
          // enough for the likely download action, then return the memory.
          this.preparedPdfExpiryTimer = window.setTimeout(() => {
            if (this.preparedPdfSignature === signature) this.releasePreparedPdfSource();
          }, 90 * 1000);
        }
        takePreparedPdfSource(signature) {
          if (!this.preparedPdfSource) return null;
          if (this.preparedPdfSignature !== signature) {
            this.releasePreparedPdfSource();
            return null;
          }
          var source = this.preparedPdfSource;
          if (this.preparedPdfExpiryTimer) window.clearTimeout(this.preparedPdfExpiryTimer);
          this.preparedPdfExpiryTimer = null;
          this.preparedPdfSource = null;
          this.preparedPdfSignature = '';
          return source;
        }
        pdfPageLayout() {
          var Pdf = window.jspdf.jsPDF;
          var pdf = new Pdf({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true });
          var margin = 12;
          return {
            pdf: pdf,
            margin: margin,
            pageWidth: pdf.internal.pageSize.getWidth() - margin * 2,
            pageHeight: pdf.internal.pageSize.getHeight() - margin * 2,
          };
        }
        schedulePdfSourcePreparation(delay) {
          if (!this.selected.size) return;
          var signature = this.pdfSelectionSignature();
          if (
            (this.preparedPdfSource && this.preparedPdfSignature === signature) ||
            (this.pdfPreparationPromise && this.pdfPreparationSignature === signature)
          )
            return;
          this.cancelScheduledPdfPreparation();
          var startWhenIdle = () => {
            this.pdfPreparationDelayTimer = null;
            var prepare = () => {
              this.pdfPreparationIdleTimer = null;
              this.preparePdfSource().catch(() => {});
            };
            if (typeof window.requestIdleCallback === 'function')
              this.pdfPreparationIdleTimer = window.requestIdleCallback(prepare, { timeout: 3000 });
            else this.pdfPreparationIdleTimer = window.setTimeout(prepare, 0);
          };
          this.pdfPreparationDelayTimer = window.setTimeout(startWhenIdle, Math.max(0, delay || 0));
        }
        async preparePdfSource() {
          if (!this.selected.size || !this.isConnected || document.visibilityState === 'hidden') return null;
          var signature = this.pdfSelectionSignature();
          if (this.preparedPdfSource && this.preparedPdfSignature !== signature)
            this.releasePreparedPdfSource();
          if (this.preparedPdfSource && this.preparedPdfSignature === signature) return this.preparedPdfSource;
          if (this.pdfPreparationPromise) {
            await this.pdfPreparationPromise.catch(() => null);
            if (!this.selected.size || !this.isConnected) return null;
            signature = this.pdfSelectionSignature();
            if (this.preparedPdfSource && this.preparedPdfSignature === signature)
              return this.preparedPdfSource;
          }
          var preparationVersion = this.pdfPreparationVersion;
          var preparationPromise = (async () => {
            if (matchMedia('(max-width: 767px)').matches) await this.loadPdfDocumentLibrary();
            else await this.loadPdfLibraries();
            var layout = this.pdfPageLayout();
            var source = await this.renderChecklistPageSource(layout.pageWidth, layout.pageHeight);
            if (
              preparationVersion !== this.pdfPreparationVersion ||
              signature !== this.pdfSelectionSignature() ||
              !this.isConnected
            ) {
              this.releaseCanvas(source.canvas);
              return null;
            }
            this.cachePreparedPdfSource(source, signature);
            return source;
          })();
          this.pdfPreparationPromise = preparationPromise;
          this.pdfPreparationSignature = signature;
          try {
            return await preparationPromise;
          } finally {
            if (this.pdfPreparationPromise === preparationPromise) {
              this.pdfPreparationPromise = null;
              this.pdfPreparationSignature = '';
            }
          }
        }
        async acquirePdfPageSource(pageWidth, pageHeight, job) {
          var signature = this.pdfSelectionSignature();
          var preparedSource = this.takePreparedPdfSource(signature);
          if (preparedSource) return preparedSource;
          if (this.pdfPreparationPromise && this.pdfPreparationSignature === signature) {
            try {
              await this.waitForDownloadTask(this.pdfPreparationPromise, job);
              this.throwIfDownloadCancelled(job);
              preparedSource = this.takePreparedPdfSource(signature);
              if (preparedSource) return preparedSource;
            } catch (error) {
              if (error && error.name === 'AbortError') throw error;
            }
          }
          return this.renderChecklistPageSource(pageWidth, pageHeight, job);
        }
        showDownloadNotice(state, messageKey, autoHideDelay) {
          if (!this.downloadNotice || !this.downloadMessage) return;
          if (this.downloadNoticeTimer) window.clearTimeout(this.downloadNoticeTimer);
          if (this.downloadNoticeCollapseTimer) window.clearTimeout(this.downloadNoticeCollapseTimer);
          if (this.downloadNoticeRevealTimer) window.clearTimeout(this.downloadNoticeRevealTimer);
          this.downloadNoticeTimer = null;
          this.downloadNoticeCollapseTimer = null;
          this.downloadNoticeRevealTimer = null;
          this.downloadNoticeAutoHideDelay = Math.max(0, Number(autoHideDelay) || 0);
          this.downloadNotice.hidden = false;
          this.downloadNotice.classList.remove('is-collapsed');
          this.downloadNotice.setAttribute('data-state', state);
          this.downloadNotice.setAttribute('aria-busy', String(state === 'busy' || state === 'cancelling'));
          this.downloadMessage.textContent = this.text(messageKey);
          if (this.downloadCompactButton)
            this.downloadCompactButton.setAttribute('aria-label', this.text(messageKey));
          if (state === 'success' || state === 'ready') this.setDownloadProgress(100);
          if (this.downloadDismissButton) {
            var isBusy = state === 'busy';
            this.downloadDismissButton.disabled = state === 'cancelling';
            this.downloadDismissButton.setAttribute(
              'aria-label',
              this.text(isBusy ? 'downloadCancel' : 'downloadDismiss')
            );
          }
          if (this.downloadSaveButton) {
            var isReady = state === 'ready';
            this.downloadSaveButton.hidden = !isReady;
            this.downloadSaveButton.disabled = !isReady || this.isSavingPreparedPdf;
          }
          if (this.downloadRetryButton) this.downloadRetryButton.hidden = state !== 'error';
          if (state === 'busy') this.scheduleDownloadNoticeCollapse();
          else if (state === 'ready' || state === 'success') {
            this.downloadNotice.classList.add('is-collapsed');
          } else if (state === 'error') {
            this.downloadNotice.classList.add('is-collapsed');
            this.downloadNoticeRevealTimer = window.setTimeout(() => {
              this.downloadNoticeRevealTimer = null;
              if (this.downloadNotice) this.downloadNotice.classList.remove('is-collapsed');
            }, 650);
          }
          if (this.downloadNoticeAutoHideDelay && state !== 'ready' && state !== 'success') {
            this.downloadNoticeTimer = window.setTimeout(
              () => this.hideDownloadNotice(),
              this.downloadNoticeAutoHideDelay
            );
          }
        }
        scheduleDownloadNoticeCollapse() {
          if (this.downloadNoticeCollapseTimer) window.clearTimeout(this.downloadNoticeCollapseTimer);
          this.downloadNoticeCollapseTimer = window.setTimeout(() => {
            this.downloadNoticeCollapseTimer = null;
            if (
              this.isDownloadingPdf &&
              this.downloadNotice &&
              this.downloadNotice.getAttribute('data-state') === 'busy'
            )
              this.downloadNotice.classList.add('is-collapsed');
          }, 2200);
        }
        expandDownloadNotice() {
          if (!this.downloadNotice) return;
          if (this.downloadNoticeRevealTimer) window.clearTimeout(this.downloadNoticeRevealTimer);
          this.downloadNoticeRevealTimer = null;
          this.downloadNotice.classList.remove('is-collapsed');
          if (this.downloadNotice.getAttribute('data-state') === 'busy') this.scheduleDownloadNoticeCollapse();
          else if (this.downloadNoticeAutoHideDelay) {
            if (this.downloadNoticeTimer) window.clearTimeout(this.downloadNoticeTimer);
            this.downloadNoticeTimer = window.setTimeout(
              () => this.hideDownloadNotice(),
              this.downloadNoticeAutoHideDelay
            );
          }
        }
        hideDownloadNotice() {
          if (this.downloadNoticeTimer) window.clearTimeout(this.downloadNoticeTimer);
          if (this.downloadNoticeCollapseTimer) window.clearTimeout(this.downloadNoticeCollapseTimer);
          if (this.downloadNoticeRevealTimer) window.clearTimeout(this.downloadNoticeRevealTimer);
          this.downloadNoticeTimer = null;
          this.downloadNoticeCollapseTimer = null;
          this.downloadNoticeRevealTimer = null;
          this.downloadNoticeAutoHideDelay = 0;
          if (this.downloadNotice) {
            this.downloadNotice.hidden = true;
            this.downloadNotice.classList.remove('is-collapsed');
          }
          this.pendingPdfFile = null;
          this.isSavingPreparedPdf = false;
        }
        setDownloadProgress(value) {
          var progress = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
          if (this.isDownloadingPdf) progress = Math.max(this.downloadProgress || 0, progress);
          this.downloadProgress = progress;
          var progressLabel = progress + '%';
          if (this.downloadNotice) {
            this.downloadNotice.style.setProperty('--download-progress', progressLabel);
            this.downloadNotice.style.setProperty('--download-progress-value', String(progress));
          }
          if (this.downloadProgressNode) {
            this.downloadProgressNode.setAttribute('data-progress-label', progressLabel);
            this.downloadProgressNode.setAttribute('aria-valuenow', String(progress));
          }
          this.querySelectorAll('[data-checklist-download]').forEach((button) => {
            button.style.setProperty('--download-progress', progressLabel);
            button.setAttribute('data-download-progress-label', progressLabel);
          });
        }
        downloadCancelledError() {
          var error = new Error('PDF download cancelled.');
          error.name = 'AbortError';
          return error;
        }
        createDownloadJob() {
          var job = {
            cancelled: false,
            cancelHandlers: new Set(),
          };
          job.cancel = () => {
            if (job.cancelled) return;
            job.cancelled = true;
            Array.from(job.cancelHandlers).forEach((handler) => handler());
            job.cancelHandlers.clear();
          };
          return job;
        }
        throwIfDownloadCancelled(job) {
          if (job && job.cancelled) throw this.downloadCancelledError();
        }
        waitForDownloadTask(promise, job) {
          if (!job) return Promise.resolve(promise);
          if (job.cancelled) return Promise.reject(this.downloadCancelledError());
          return new Promise((resolve, reject) => {
            var onCancel = () => {
              job.cancelHandlers.delete(onCancel);
              reject(this.downloadCancelledError());
            };
            job.cancelHandlers.add(onCancel);
            Promise.resolve(promise).then(
              (value) => {
                job.cancelHandlers.delete(onCancel);
                resolve(value);
              },
              (error) => {
                job.cancelHandlers.delete(onCancel);
                reject(error);
              }
            );
          });
        }
        async yieldToMainThread(job) {
          await this.waitForDownloadTask(
            new Promise((resolve) => window.setTimeout(resolve, 0)),
            job
          );
          this.throwIfDownloadCancelled(job);
        }
        cancelPdfDownload() {
          if (!this.isDownloadingPdf || !this.downloadJob) {
            this.hideDownloadNotice();
            return;
          }
          this.downloadJob.cancel();
          this.showDownloadNotice('cancelling', 'downloadCancelling');
        }
        isIosDevice() {
          return (
            /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
          );
        }
        canSharePdfFile(file) {
          if (!this.isIosDevice() || !file || typeof navigator.share !== 'function') return false;
          if (typeof navigator.canShare !== 'function') return false;
          try {
            return navigator.canShare({ files: [file] });
          } catch (error) {
            return false;
          }
        }
        prepareIosPdfSave(pdf, filename) {
          if (!this.isIosDevice() || typeof File !== 'function') return false;
          var file = null;
          try {
            file = new File([pdf.output('blob')], filename, {
              type: 'application/pdf',
              lastModified: Date.now(),
            });
          } catch (error) {
            return false;
          }
          if (!this.canSharePdfFile(file)) return false;
          this.pendingPdfFile = file;
          this.showDownloadNotice('ready', 'downloadReady');
          return true;
        }
        async savePreparedPdf() {
          var file = this.pendingPdfFile;
          if (!file || this.isSavingPreparedPdf) return;
          if (!this.canSharePdfFile(file)) {
            this.pendingPdfFile = null;
            this.showDownloadNotice('error', 'downloadError');
            return;
          }
          this.isSavingPreparedPdf = true;
          if (this.downloadSaveButton) this.downloadSaveButton.disabled = true;
          try {
            await navigator.share({ files: [file], title: file.name });
            this.pendingPdfFile = null;
            this.showDownloadNotice('success', 'downloadSaved', 5000);
          } catch (error) {
            if (error && error.name === 'AbortError') {
              this.showDownloadNotice('ready', 'downloadReady');
            } else {
              console.error('Pregnancy checklist PDF save failed.', error);
              this.pendingPdfFile = null;
              this.showDownloadNotice('error', 'downloadError');
            }
          } finally {
            this.isSavingPreparedPdf = false;
            if (this.downloadSaveButton && !this.downloadSaveButton.hidden)
              this.downloadSaveButton.disabled = !this.pendingPdfFile;
          }
        }
        loadPdfScript(id, src, test) {
          if (test()) return Promise.resolve();
          return new Promise((resolve, reject) => {
            var script = document.getElementById(id);
            if (script && script.getAttribute('data-pdf-load-state') === 'failed') {
              script.remove();
              script = null;
            }
            var onLoad = () => {
              script.setAttribute('data-pdf-load-state', 'loaded');
              if (test()) resolve();
              else {
                script.remove();
                reject(new Error('PDF library loaded without exposing its API.'));
              }
            };
            var onError = () => {
              script.setAttribute('data-pdf-load-state', 'failed');
              script.remove();
              reject(new Error('Unable to load a PDF library.'));
            };
            if (script) {
              if (script.getAttribute('data-pdf-load-state') === 'loaded') {
                onLoad();
                return;
              }
              script.addEventListener('load', onLoad, { once: true });
              script.addEventListener('error', onError, { once: true });
              return;
            }
            script = document.createElement('script');
            script.id = id;
            script.src = src;
            script.async = true;
            script.setAttribute('data-pdf-load-state', 'loading');
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            document.head.appendChild(script);
          });
        }
        loadPdfLibraries() {
          if (this.pdfLibrariesPromise) return this.pdfLibrariesPromise;
          this.pdfLibrariesPromise = Promise.all([this.loadCanvasLibrary(), this.loadPdfDocumentLibrary()]).catch(
            (error) => {
              this.pdfLibrariesPromise = null;
              throw error;
            }
          );
          return this.pdfLibrariesPromise;
        }
        loadCanvasLibrary() {
          if (this.canvasLibraryPromise) return this.canvasLibraryPromise;
          this.canvasLibraryPromise = this.loadPdfScript(
            'pregnancy-checklist-html2canvas',
            'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js',
            () => typeof window.html2canvas === 'function'
          ).catch((error) => {
            this.canvasLibraryPromise = null;
            this.pdfLibrariesPromise = null;
            throw error;
          });
          return this.canvasLibraryPromise;
        }
        loadPdfDocumentLibrary() {
          if (this.pdfDocumentLibraryPromise) return this.pdfDocumentLibraryPromise;
          this.pdfDocumentLibraryPromise = this.loadPdfScript(
            'pregnancy-checklist-jspdf',
            'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js',
            () => !!(window.jspdf && window.jspdf.jsPDF)
          ).catch((error) => {
            this.pdfDocumentLibraryPromise = null;
            this.pdfLibrariesPromise = null;
            throw error;
          });
          return this.pdfDocumentLibraryPromise;
        }
        waitForPreviewImages(container) {
          return Promise.all(
            Array.prototype.slice.call(container.querySelectorAll('img')).map((image) => {
              if (image.complete && image.naturalWidth) return Promise.resolve();
              if (image.complete) return Promise.reject(new Error('A checklist PDF image failed to load.'));
              return new Promise((resolve, reject) => {
                image.addEventListener('load', resolve, { once: true });
                image.addEventListener(
                  'error',
                  () => reject(new Error('A checklist PDF image failed to load.')),
                  { once: true }
                );
              });
            })
          );
        }
        setDownloadBusy(isBusy) {
          this.querySelectorAll('[data-checklist-download]').forEach((button) => {
            button.disabled = isBusy || !this.selected.size;
            button.setAttribute('aria-busy', String(isBusy));
            if (!isBusy) {
              button.style.removeProperty('--download-progress');
              button.removeAttribute('data-download-progress-label');
            }
          });
        }
        setPrintBusy(isBusy) {
          this.querySelectorAll('[data-checklist-print]').forEach((button) => {
            button.disabled = isBusy || !this.selected.size;
            button.setAttribute('aria-busy', String(isBusy));
          });
        }
        printStatusHtml(title, message, isError) {
          return (
            '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
            '<title>' +
            title +
            '</title><style>html,body{min-height:100%;margin:0}body{display:grid;min-height:100vh;place-items:center;padding:24px;box-sizing:border-box;background:#f9f1eb;color:#1a1a1a;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}.print-status{display:flex;width:min(360px,100%);align-items:center;gap:14px;border:1px solid #e1d8d2;border-radius:16px;padding:18px;background:#fff;box-shadow:0 8px 28px rgba(0,0,0,.12)}.print-status__spinner{width:20px;height:20px;flex:0 0 20px;box-sizing:border-box;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:print-status-spin .7s linear infinite}.print-status__error{width:20px;height:20px;flex:0 0 20px;color:#a52626;font-size:20px;font-weight:700;line-height:20px;text-align:center}.print-status p{margin:0;font-size:15px;line-height:22px}@keyframes print-status-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.print-status__spinner{animation-duration:1.5s}}</style></head><body><main class="print-status" role="status" aria-live="polite">' +
            (isError
              ? '<span class="print-status__error" aria-hidden="true">!</span>'
              : '<span class="print-status__spinner" aria-hidden="true"></span>') +
            '<p>' +
            this.escape(message) +
            '</p></main></body></html>'
          );
        }
        waitForPrintWindowPaint(printWindow) {
          return new Promise((resolve) => {
            var isResolved = false;
            var fallbackTimer = null;
            var finish = () => {
              if (isResolved) return;
              isResolved = true;
              if (fallbackTimer) window.clearTimeout(fallbackTimer);
              resolve();
            };
            fallbackTimer = window.setTimeout(finish, 500);
            try {
              // Force the status document to finish layout, then wait until a task
              // after two animation frames so the browser can paint it before
              // html2canvas starts its main-thread-heavy capture.
              printWindow.document.documentElement.getBoundingClientRect();
              printWindow.requestAnimationFrame(() => {
                printWindow.requestAnimationFrame(() => {
                  printWindow.setTimeout(finish, 0);
                });
              });
            } catch (error) {
              window.setTimeout(finish, 0);
            }
          });
        }
        pdfSafeBreaks(capture, canvas) {
          var captureRect = capture.getBoundingClientRect();
          var renderScale = canvas.width / Math.max(1, captureRect.width);
          var breakGap = Math.round(4 * renderScale);
          var breaks = [];
          var addBreak = (bottom) => {
            var value = Math.round((bottom - captureRect.top) * renderScale) + breakGap;
            if (value > 0 && value < canvas.height) breaks.push(value);
          };
          Array.prototype.slice
            .call(capture.querySelectorAll('.yg-pregnancy-checklist-builder__preview-document-cards'))
            .forEach((cards) => {
              var rows = {};
              Array.prototype.slice.call(cards.children).forEach((card) => {
                var cardRect = card.getBoundingClientRect();
                var rowTop = Math.round(cardRect.top - captureRect.top);
                rows[rowTop] = Math.max(rows[rowTop] || 0, cardRect.bottom);
              });
              Object.keys(rows).forEach((rowTop) => addBreak(rows[rowTop]));
            });
          Array.prototype.slice
            .call(
              capture.querySelectorAll(
                '.yg-pregnancy-checklist-builder__preview-document-group > .yg-pregnancy-checklist-builder__preview-document-card'
              )
            )
            .forEach((card) => addBreak(card.getBoundingClientRect().bottom));
          return breaks.sort((a, b) => a - b).filter((value, index, values) => !index || value !== values[index - 1]);
        }
        checklistPageSliceRects(capture, canvas, pageWidth, pageHeight) {
          var sourcePageHeight = Math.max(1, Math.ceil((canvas.width * pageHeight) / pageWidth));
          var safeBreaks = this.pdfSafeBreaks(capture, canvas);
          var slices = [];
          var sourceTop = 0;
          while (sourceTop < canvas.height) {
            var remainingSourceHeight = canvas.height - sourceTop;
            var isLastPage = remainingSourceHeight <= sourcePageHeight;
            var maxSourceBottom = Math.min(sourceTop + sourcePageHeight, canvas.height);
            var sourceBottom = canvas.height;
            if (!isLastPage) {
              var minimumUsefulBreak = sourceTop + Math.floor(sourcePageHeight * 0.35);
              var safeBottom = safeBreaks
                .filter((value) => value >= minimumUsefulBreak && value <= maxSourceBottom)
                .pop();
              sourceBottom = safeBottom || maxSourceBottom;
            }
            if (sourceBottom <= sourceTop) sourceBottom = maxSourceBottom;
            var sliceHeight = sourceBottom - sourceTop;
            slices.push({ sourceTop: sourceTop, sliceHeight: sliceHeight });
            sourceTop = sourceBottom;
          }
          return slices;
        }
        createChecklistPageSlice(sourceCanvas, sliceRect) {
          var slice = document.createElement('canvas');
          slice.width = sourceCanvas.width;
          slice.height = sliceRect.sliceHeight;
          slice
            .getContext('2d')
            .drawImage(
              sourceCanvas,
              0,
              sliceRect.sourceTop,
              sourceCanvas.width,
              sliceRect.sliceHeight,
              0,
              0,
              sourceCanvas.width,
              sliceRect.sliceHeight
            );
          return slice;
        }
        releaseCanvas(canvas) {
          if (!canvas) return;
          canvas.width = 0;
          canvas.height = 0;
        }
        async renderChecklistPageSource(pageWidth, pageHeight, job) {
          if (
            matchMedia('(max-width: 767px)').matches &&
            window.YGPregnancyChecklistPdfPainter
          ) {
            try {
              return await window.YGPregnancyChecklistPdfPainter.render(this, pageWidth, pageHeight, job);
            } catch (error) {
              if (error && error.name === 'AbortError') throw error;
              console.warn('Fast pregnancy checklist PDF rendering failed; using DOM capture fallback.', error);
            }
          }
          return this.renderChecklistPageSourceWithHtml2Canvas(pageWidth, pageHeight, job);
        }
        async renderChecklistPageSourceWithHtml2Canvas(pageWidth, pageHeight, job) {
          var capture = document.createElement('article');
          var canvas = null;
          capture.className =
            'yg-pregnancy-checklist-builder__preview-page yg-pregnancy-checklist-builder__pdf-capture';
          capture.innerHTML = this.previewHtml();
          document.body.appendChild(capture);
          try {
            await this.waitForDownloadTask(this.loadCanvasLibrary(), job);
            if (job) this.setDownloadProgress(30);
            if (document.fonts && document.fonts.ready)
              await this.waitForDownloadTask(document.fonts.ready, job);
            if (job) this.setDownloadProgress(35);
            await this.preloadPdfImagesWithProgress(
              Array.prototype.slice.call(capture.querySelectorAll('img')).map((image) => image.src),
              job,
              35,
              55
            );
            await this.waitForDownloadTask(this.waitForPreviewImages(capture), job);
            if (job) this.setDownloadProgress(60);
            this.replacePdfImagesWithCachedCanvases(capture);
            this.throwIfDownloadCancelled(job);
            if (job) this.setDownloadProgress(64);
            // html2canvas cannot be aborted safely. Finish this render, then honor a queued cancellation
            // before creating any PDF pages so the temporary canvas can always be released.
            canvas = await window.html2canvas(capture, {
              backgroundColor: '#f9f1eb',
              scale: this.pdfRenderScale(),
              useCORS: true,
              imageTimeout: 0,
              logging: false,
            });
            if (job) this.setDownloadProgress(72);
            await this.yieldToMainThread(job);
            return {
              canvas: canvas,
              slices: this.checklistPageSliceRects(capture, canvas, pageWidth, pageHeight),
            };
          } catch (error) {
            this.releaseCanvas(canvas);
            throw error;
          } finally {
            capture.remove();
          }
        }
        async downloadPdf() {
          if (!this.selected.size || this.isDownloadingPdf) return;
          this.isDownloadingPdf = true;
          this.downloadJob = this.createDownloadJob();
          var job = this.downloadJob;
          var pageSource = null;
          this.pendingPdfFile = null;
          this.downloadProgress = 0;
          this.setDownloadProgress(0);
          this.setDownloadBusy(true);
          this.showDownloadNotice('busy', 'downloadPreparing');
          try {
            await this.yieldToMainThread(job);
            this.setDownloadProgress(4);
            var pdfLibraryPromise = matchMedia('(max-width: 767px)').matches
              ? this.loadPdfDocumentLibrary()
              : this.loadPdfLibraries();
            await this.waitForDownloadTask(pdfLibraryPromise, job);
            this.setDownloadProgress(15);
            var layout = this.pdfPageLayout();
            var pdf = layout.pdf;
            var margin = layout.margin;
            var pageWidth = layout.pageWidth;
            var pageHeight = layout.pageHeight;
            this.setDownloadProgress(20);
            pageSource = await this.acquirePdfPageSource(pageWidth, pageHeight, job);
            this.setDownloadProgress(72);
            for (var pageIndex = 0; pageIndex < pageSource.slices.length; pageIndex += 1) {
              this.throwIfDownloadCancelled(job);
              if (pageIndex) pdf.addPage();
              var slice = this.createChecklistPageSlice(pageSource.canvas, pageSource.slices[pageIndex]);
              try {
                var useMobileJpeg = matchMedia('(max-width: 767px)').matches;
                pdf.addImage(
                  slice.toDataURL(useMobileJpeg ? 'image/jpeg' : 'image/png', useMobileJpeg ? 0.92 : undefined),
                  useMobileJpeg ? 'JPEG' : 'PNG',
                  margin,
                  margin,
                  pageWidth,
                  (slice.height * pageWidth) / slice.width,
                  undefined,
                  useMobileJpeg ? 'FAST' : undefined
                );
              } finally {
                this.releaseCanvas(slice);
              }
              this.setDownloadProgress(72 + (24 * (pageIndex + 1)) / pageSource.slices.length);
              await this.yieldToMainThread(job);
            }
            this.throwIfDownloadCancelled(job);
            this.setDownloadProgress(98);
            var filename = (this.text('pdfFilename') || 'pregnancy-checklist')
              .replace(/[\\/:*?"<>|]+/g, '-')
              .replace(/\s+/g, '-');
            filename = filename.replace(/\.pdf$/i, '') + '.pdf';
            if (!this.prepareIosPdfSave(pdf, filename)) {
              pdf.save(filename);
              this.setDownloadProgress(100);
              this.showDownloadNotice('success', 'downloadSuccess', 5000);
            }
          } catch (error) {
            if (error && error.name === 'AbortError') {
              this.showDownloadNotice('cancelled', 'downloadCancelled', 4000);
            } else {
              console.error('Pregnancy checklist PDF download failed.', error);
              this.showDownloadNotice('error', 'downloadError');
            }
          } finally {
            if (pageSource) this.releaseCanvas(pageSource.canvas);
            if (this.downloadJob === job) this.downloadJob = null;
            this.isDownloadingPdf = false;
            this.setDownloadBusy(false);
          }
        }
        async printChecklist() {
          if (!this.selected.size || this.isPrintingChecklist) return;
          this.isPrintingChecklist = true;
          this.setPrintBusy(true);
          // Open synchronously from the click handler so browsers do not block the print window.
          var printWindow = window.open('', '_blank');
          if (!printWindow) {
            console.warn('Pregnancy checklist print window was blocked.');
            this.isPrintingChecklist = false;
            this.setPrintBusy(false);
            return;
          }
          var title = this.escape(this.text('summaryTitle'));
          printWindow.document.open();
          printWindow.document.write(this.printStatusHtml(title, this.text('printPreparing'), false));
          printWindow.document.close();
          printWindow.focus();
          var pageSource = null;
          try {
            await this.waitForPrintWindowPaint(printWindow);
            if (printWindow.closed) return;
            var margin = 12;
            var pageWidth = 210 - margin * 2;
            var pageHeight = 297 - margin * 2;
            pageSource = await this.acquirePdfPageSource(pageWidth, pageHeight);
            if (printWindow.closed) return;
            var pages = [];
            for (var pageIndex = 0; pageIndex < pageSource.slices.length; pageIndex += 1) {
              var slice = this.createChecklistPageSlice(pageSource.canvas, pageSource.slices[pageIndex]);
              try {
                pages.push(
                  '<section class="checklist-print-page"><img src="' +
                    slice.toDataURL('image/png') +
                    '" alt=""></section>'
                );
              } finally {
                this.releaseCanvas(slice);
              }
              await this.yieldToMainThread();
            }
            printWindow.document.open();
            printWindow.document.write(
              '<!doctype html><html><head><meta charset="utf-8"><title>' +
                title +
                '</title><style>@page{size:A4 portrait;margin:12mm}html,body{margin:0;padding:0;background:#fff}body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.checklist-print-page{width:186mm;height:273mm;overflow:hidden;break-after:page;page-break-after:always;break-inside:avoid;page-break-inside:avoid}.checklist-print-page:last-child{break-after:auto;page-break-after:auto}.checklist-print-page img{display:block;width:186mm;max-height:273mm;object-fit:contain;object-position:left top}</style></head><body>' +
                pages.join('') +
                '</body></html>'
            );
            printWindow.document.close();
            var images = Array.prototype.slice.call(printWindow.document.querySelectorAll('img'));
            await Promise.all(
              images.map((image) => {
                if (image.complete && image.naturalWidth) return Promise.resolve();
                return new Promise((resolve) => {
                  image.addEventListener('load', resolve, { once: true });
                  image.addEventListener('error', resolve, { once: true });
                });
              })
            );
            if (printWindow.closed) return;
            printWindow.addEventListener('afterprint', () => printWindow.close(), { once: true });
            printWindow.focus();
            printWindow.print();
          } catch (error) {
            console.error('Pregnancy checklist print failed.', error);
            if (!printWindow.closed) {
              printWindow.document.open();
              printWindow.document.write(this.printStatusHtml(title, this.text('printError'), true));
              printWindow.document.close();
            }
          } finally {
            if (pageSource) this.releaseCanvas(pageSource.canvas);
            this.isPrintingChecklist = false;
            this.setPrintBusy(false);
          }
        }
        selectionHtml() {
          var momActive = this.tab === 'mom';
          var html =
            '<div class="yg-pregnancy-checklist-builder__tabs" role="tablist" aria-label="' +
            this.escape(this.text('tabLabel')) +
            '"><button class="yg-pregnancy-checklist-builder__tab ' +
            (momActive ? 'is-active' : '') +
            '" type="button" role="tab" aria-selected="' +
            momActive +
            '" data-checklist-tab="mom">' +
            this.escape(this.text('forMom')) +
            '</button><button class="yg-pregnancy-checklist-builder__tab ' +
            (!momActive ? 'is-active' : '') +
            '" type="button" role="tab" aria-selected="' +
            !momActive +
            '" data-checklist-tab="baby">' +
            this.escape(this.text('forBaby')) +
            '</button></div><div class="yg-pregnancy-checklist-builder__selection-panel">';
          var items = this.tab === 'mom' ? null : this.data.baby || [];
          if (items)
            return (
              html +
              '<div class="yg-pregnancy-checklist-builder__items">' +
              items.map((item) => this.checkHtml(item)).join('') +
              '</div></div>'
            );
          (this.data.mom || []).forEach((group) => {
            var isOpen = !!this.opened[group.key];
            var selectedCount = this.selectedItems(group.items).length;
            html +=
              '<div class="yg-pregnancy-checklist-builder__accordion" data-checklist-accordion-shell="' +
              this.escape(group.key) +
              '"><button type="button" class="yg-pregnancy-checklist-builder__accordion-button" aria-expanded="' +
              isOpen +
              '" data-checklist-accordion="' +
              this.escape(group.key) +
              '"><span>' +
              this.escape(group.title) +
              ' (' +
              selectedCount +
              ')</span><span class="yg-pregnancy-checklist-builder__chevron" aria-hidden="true">' +
              this.icon('chevron') +
              '</span></button><div class="yg-pregnancy-checklist-builder__accordion-panel' +
              (isOpen ? ' is-open' : '') +
              '" data-checklist-accordion-panel="' +
              this.escape(group.key) +
              '" aria-hidden="' +
              !isOpen +
              '"><div class="yg-pregnancy-checklist-builder__accordion-panel-inner"><div class="yg-pregnancy-checklist-builder__items">' +
              group.items.map((item) => this.checkHtml(item)).join('') +
              '</div></div></div></div>';
          });
          return html + '</div>';
        }
        checkHtml(item) {
          return (
            '<label class="yg-pregnancy-checklist-builder__check"><input type="checkbox" data-checklist-item="' +
            this.escape(item.id) +
            '"' +
            (this.selected.has(item.id) ? ' checked' : '') +
            '><span class="yg-pregnancy-checklist-builder__check-mark">' +
            this.icon('check') +
            '</span><span>' +
            this.escape(item.name) +
            '</span></label>'
          );
        }
        render() {
          var count = this.selected.size;
          var countText = this.escape(this.text('selectedCount', { count: count }));
          var summaryImage = this.data.desktopSummaryImage
            ? '<img data-checklist-image-key="summary-header" src="' +
              this.escape(this.data.desktopSummaryImage) +
              '" alt="">'
            : '';
          var summaryVisual =
            '<div class="yg-pregnancy-checklist-builder__summary-visual' +
            (this.data.desktopSummaryImage ? ' has-image' : '') +
            '">' +
            summaryImage +
            '<h3 class="yg-pregnancy-checklist-builder__summary-title">' +
            this.escape(this.text('summaryTitle')) +
            '</h3></div>';
          this.selection.innerHTML = this.selectionHtml();
          this.countNodes.forEach((node) => {
            node.textContent = count;
          });
          if (this.drawerOpenButton) {
            this.drawerOpenButton.disabled = count === 0;
            this.drawerOpenButton.setAttribute('aria-disabled', String(count === 0));
          }
          this.setHtmlPreservingImages(
            this.summary,
            summaryVisual +
            '<div class="yg-pregnancy-checklist-builder__summary-meta"><span>' +
            countText +
            '</span><button class="yg-pregnancy-checklist-builder__clear" type="button" data-checklist-clear' +
            (count ? '' : ' disabled') +
            '>' +
            this.escape(this.text('clearAll')) +
            '</button></div><div class="yg-pregnancy-checklist-builder__summary-content">' +
            this.selectedHtml() +
            '</div><div class="yg-pregnancy-checklist-builder__tools">' +
            this.toolsHtml() +
            '</div>'
          );
          this.setHtmlPreservingImages(
            this.drawerContent,
            '<div class="yg-pregnancy-checklist-builder__drawer-count"><span>' +
            countText +
            '</span><button class="yg-pregnancy-checklist-builder__clear" type="button" data-checklist-clear' +
            (count ? '' : ' disabled') +
            '>' +
            this.escape(this.text('clearAll')) +
            '</button></div>' +
            this.selectedHtml({ drawer: true })
          );
          this.drawerTools.innerHTML = this.toolsHtml();
          this.syncShareButtons();
          if (this.preview && !this.preview.hidden) this.renderPreview();
          this.renderRelatedProducts();
          if (count) {
            this.schedulePdfLibrariesPreload();
            // Keep selection changes lightweight: warm only the required
            // images here. Full document rendering is reserved for preview/download.
            this.scheduleSelectedPdfImagesPreload(800);
          } else this.cancelScheduledSelectedPdfImagesPreload();
        }
        update(id, checked) {
          if (!this.items[id]) return;
          var wasSelected = this.selected.has(id);
          if (checked) this.selected.add(id);
          else this.selected.delete(id);
          if (wasSelected === this.selected.has(id)) return;
          this.invalidatePreparedPdfSource();
          this.save();
          this.render();
          this.emitChecklistEvent('YG:pregnancy-checklist-change');
        }
        clear() {
          var hadSelection = this.selected.size > 0;
          this.selected.clear();
          this.invalidatePreparedPdfSource();
          if (this.sharePrepareTimer) window.clearTimeout(this.sharePrepareTimer);
          this.sharePrepareTimer = null;
          this.sharePrepareVersion += 1;
          this.isSharePreparing = false;
          try {
            localStorage.removeItem(this.storageKey);
          } catch (error) {}
          this.render();
          if (hadSelection) this.emitChecklistEvent('YG:pregnancy-checklist-change');
        }
        setAccordion(key) {
          var shouldOpen = !this.opened[key];
          var headers = this.selection.querySelectorAll('[data-checklist-accordion]');
          Object.keys(this.opened).forEach((name) => {
            this.opened[name] = shouldOpen && name === key;
          });
          headers.forEach((header) => {
            var isOpen = !!this.opened[header.getAttribute('data-checklist-accordion')];
            var panel = header
              .closest('.yg-pregnancy-checklist-builder__accordion')
              .querySelector('[data-checklist-accordion-panel]');
            header.setAttribute('aria-expanded', String(isOpen));
            if (panel) {
              panel.classList.toggle('is-open', isOpen);
              panel.setAttribute('aria-hidden', String(!isOpen));
            }
          });
        }
        toggleDrawerCard(key) {
          if (!this.drawerContent || matchMedia('(min-width: 1024px)').matches) return;
          this.drawerOpened[key] = !this.drawerOpened[key];
          var buttons = this.drawerContent.querySelectorAll('[data-checklist-drawer-card]');
          buttons.forEach((button) => {
            if (button.getAttribute('data-checklist-drawer-card') !== key) return;
            var isOpen = !!this.drawerOpened[key];
            var panel = document.getElementById(button.getAttribute('aria-controls'));
            button.setAttribute('aria-expanded', String(isOpen));
            if (panel) {
              panel.setAttribute('aria-hidden', String(!isOpen));
              var activeAnimation = panel._ygHeightAnimation;
              var currentHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;
              if (activeAnimation) {
                activeAnimation.onfinish = null;
                activeAnimation.cancel();
                panel._ygHeightAnimation = null;
              }
              if (!panel.animate || !panel.getAnimations || matchMedia('(prefers-reduced-motion: reduce)').matches) {
                panel.hidden = !isOpen;
                panel.style.height = isOpen ? 'auto' : '0px';
                panel.style.willChange = '';
                return;
              }
              if (isOpen) {
                panel.hidden = false;
                panel.style.height = 'auto';
              }
              var expandedHeight = isOpen ? panel.getBoundingClientRect().height : 0;
              panel.style.height = currentHeight + 'px';
              panel.style.willChange = 'height';
              var animation = panel.animate(
                [
                  { height: currentHeight + 'px' },
                  { height: expandedHeight + 'px' },
                ],
                {
                  duration: isOpen ? 400 : 340,
                  easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                  fill: 'both',
                }
              );
              panel._ygHeightAnimation = animation;
              animation.onfinish = () => {
                if (!!this.drawerOpened[key] !== isOpen) return;
                panel.style.height = isOpen ? 'auto' : '0px';
                panel.style.willChange = '';
                panel.hidden = !isOpen;
                animation.cancel();
                panel._ygHeightAnimation = null;
              };
            }
          });
        }

        scrollToChecklist() {
          var target = this.querySelector('.yg-pregnancy-checklist-builder__intro') || this;
          var stickyHeader = document.querySelector('header.shopify-section-header-sticky');
          var anchorNav = document.querySelector('[data-anchor-nav-root]');
          var anchorSection = anchorNav && anchorNav.closest('.shopify-section');
          var headerHeight = stickyHeader && window.getComputedStyle(stickyHeader).display !== 'none'
            ? stickyHeader.offsetHeight
            : 0;
          var anchorHeight = anchorSection && window.getComputedStyle(anchorSection).display !== 'none'
            ? anchorSection.offsetHeight
            : 0;
          var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - anchorHeight - 16;

          window.scrollTo({
            top: Math.max(0, top),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }

        onClick(event) {
          var accordionShell = event.target.closest('[data-checklist-accordion-shell]');
          if (accordionShell && event.target === accordionShell) {
            this.setAccordion(accordionShell.getAttribute('data-checklist-accordion-shell'));
            return;
          }
          var target = event.target.closest('button, a');
          if (!target || !this.contains(target)) return;
          if (target.disabled || target.getAttribute('aria-disabled') === 'true') return;
          if (target.hasAttribute('data-related-quickshop-id')) {
            var quickshopProduct = this.relatedProductMap.get(target.getAttribute('data-related-quickshop-id'));
            if (quickshopProduct) this.openRelatedQuickshop(quickshopProduct);
          } else if (target.hasAttribute('data-related-quickshop-option')) {
            this.selectRelatedQuickshopOption(
              Number(target.getAttribute('data-related-quickshop-option-index')),
              target.getAttribute('data-related-quickshop-option-value')
            );
          } else if (target.hasAttribute('data-related-quickshop-quantity')) {
            this.changeRelatedQuickshopQuantity(target.getAttribute('data-related-quickshop-quantity'));
          } else if (target.hasAttribute('data-related-back-to-checklist')) {
            this.scrollToChecklist();
          } else if (target.hasAttribute('data-related-product-id')) {
            var relatedProduct = this.relatedProductMap.get(target.getAttribute('data-related-product-id'));
            if (!relatedProduct) return;
            if (this.isRelatedProductAdded(relatedProduct)) {
              this.removeRelatedProduct(relatedProduct);
              return;
            }
            var relatedVariants = relatedProduct.variants || [];
            var defaultVariant =
              relatedVariants.find(
                (variant) => String(variant.id) === String(relatedProduct.defaultVariantId) && variant.available
              ) || relatedVariants.find((variant) => variant.available);
            if (defaultVariant) this.addRelatedVariant(relatedProduct, defaultVariant);
          } else if (target.hasAttribute('data-checklist-preview-open')) {
            this.openPreview();
          } else if (target.hasAttribute('data-checklist-download-cancel')) {
            this.cancelPdfDownload();
          } else if (target.hasAttribute('data-checklist-download-notice-expand')) {
            this.expandDownloadNotice();
          } else if (target.hasAttribute('data-checklist-download-retry')) {
            this.downloadPdf();
          } else if (target.hasAttribute('data-checklist-download-save')) {
            this.savePreparedPdf();
          } else if (target.hasAttribute('data-checklist-download')) {
            this.downloadPdf();
          } else if (target.hasAttribute('data-checklist-print')) {
            this.printChecklist();
          } else if (target.hasAttribute('data-checklist-share')) {
            this.shareChecklist(target.getAttribute('data-checklist-share'));
          } else if (target.hasAttribute('data-checklist-preview-close')) {
            this.closePreview();
          } else if (target.hasAttribute('data-checklist-preview-zoom-out')) {
            this.setPreviewZoom(this.previewZoom - 0.1);
          } else if (target.hasAttribute('data-checklist-preview-zoom-in')) {
            this.setPreviewZoom(this.previewZoom + 0.1);
          } else if (target.hasAttribute('data-checklist-preview-fit')) {
            this.fitPreview();
          } else if (target.hasAttribute('data-checklist-preview-fullscreen')) {
            this.togglePreviewFullscreen();
          } else if (target.hasAttribute('data-checklist-tab')) {
            this.tab = target.getAttribute('data-checklist-tab');
            this.render();
          } else if (target.hasAttribute('data-checklist-drawer-card'))
            this.toggleDrawerCard(target.getAttribute('data-checklist-drawer-card'));
          else if (target.hasAttribute('data-checklist-accordion'))
            this.setAccordion(target.getAttribute('data-checklist-accordion'));
          else if (target.hasAttribute('data-checklist-remove'))
            this.update(target.getAttribute('data-checklist-remove'), false);
          else if (target.hasAttribute('data-checklist-clear') && this.selected.size && window.DsmDialog)
            window.DsmDialog.open(this.dialogId);
        }
        onChange(event) {
          var item = event.target.closest('[data-checklist-item]');
          if (item) this.update(item.getAttribute('data-checklist-item'), item.checked);
        }
        openDrawer() {
          if (!this.selected.size || matchMedia('(min-width: 1024px)').matches) return;
          if (this.drawerCloseTimer) {
            window.clearTimeout(this.drawerCloseTimer);
            this.drawerCloseTimer = null;
          }
          if (this.drawer.hidden) {
            this.lastFocus = document.activeElement;
            this.originalOverflow = document.body.style.overflow;
            this.drawer.hidden = false;
          }
          document.body.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onDrawerKeydown);
          window.requestAnimationFrame(() => {
            if (!this.drawer.hidden) this.drawer.classList.add('is-open');
          });
          var close = this.drawer.querySelector('[data-checklist-drawer-close]');
          if (close) close.focus();
        }
        closeDrawer(immediate) {
          if (!this.drawer || this.drawer.hidden) return;
          this.drawer.classList.remove('is-open');
          document.removeEventListener('keydown', this.onDrawerKeydown);
          var finish = () => {
            this.drawer.hidden = true;
            document.body.style.overflow = this.originalOverflow || '';
            if (this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus();
            this.lastFocus = null;
            this.drawerCloseTimer = null;
          };
          if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
          else this.drawerCloseTimer = window.setTimeout(finish, 320);
        }
        openPreview() {
          if (!this.preview) return;
          this.preloadPdfLibraries();
          if (this.previewCloseTimer) {
            window.clearTimeout(this.previewCloseTimer);
            this.previewCloseTimer = null;
          }
          if (this.preview.hidden) {
            this.lastPreviewFocus = document.activeElement;
            this.previewOriginalOverflow = document.body.style.overflow;
            this.preview.hidden = false;
          }
          document.body.style.overflow = 'hidden';
          if (this.drawer && !this.drawer.hidden && matchMedia('(max-width: 1023px)').matches)
            this.drawer.classList.add('is-previewing');
          this.isPreviewPageFullscreen = false;
          this.preview.classList.remove('is-page-fullscreen');
          this.syncPreviewFullscreenButton();
          this.renderPreview();
          // Preview signals strong download intent. Mobile uses the lightweight
          // checklist painter; desktop keeps the pixel-identical DOM capture path.
          this.schedulePdfSourcePreparation(0);
          document.addEventListener('keydown', this.onPreviewKeydown);
          window.requestAnimationFrame(() => {
            if (!this.preview.hidden) {
              this.preview.classList.add('is-open');
              if (matchMedia('(max-width: 767px)').matches) this.fitMobilePreview();
            }
          });
          var close = this.preview.querySelector('[data-checklist-preview-close]');
          if (close) close.focus();
        }
        closePreview(immediate) {
          if (!this.preview || this.preview.hidden) return;
          this.cancelScheduledPdfPreparation();
          this.preview.classList.remove('is-open');
          document.removeEventListener('keydown', this.onPreviewKeydown);
          var finish = () => {
            this.preview.hidden = true;
            this.isPreviewPageFullscreen = false;
            this.preview.classList.remove('is-page-fullscreen');
            this.syncPreviewFullscreenButton();
            if (this.drawer) this.drawer.classList.remove('is-previewing');
            document.body.style.overflow = this.previewOriginalOverflow || '';
            if (this.lastPreviewFocus && document.contains(this.lastPreviewFocus)) this.lastPreviewFocus.focus();
            this.lastPreviewFocus = null;
            this.previewCloseTimer = null;
          };
          if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
          else this.previewCloseTimer = window.setTimeout(finish, 220);
        }
        onPreviewResize() {
          if (!this.preview || this.preview.hidden) return;
          if (this.isPreviewPageFullscreen) {
            this.previewZoom = 1;
            this.syncPreviewCanvas();
          } else if (this.previewFitActive && matchMedia('(max-width: 767px)').matches) this.fitMobilePreview();
          else if (this.previewFitActive) this.fitPreview();
          else this.syncPreviewCanvas();
        }
        onPreviewKeydown(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            if (this.isPreviewPageFullscreen) this.togglePreviewFullscreen();
            else this.closePreview();
            return;
          }
          if (event.key !== 'Tab') return;
          var list = Array.prototype.slice.call(
            this.preview.querySelectorAll(
              'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
          );
          if (!list.length) return;
          if (event.shiftKey && document.activeElement === list[0]) {
            event.preventDefault();
            list[list.length - 1].focus();
          } else if (!event.shiftKey && document.activeElement === list[list.length - 1]) {
            event.preventDefault();
            list[0].focus();
          }
        }
        onDrawerKeydown(event) {
          if (this.preview && !this.preview.hidden) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeDrawer();
            return;
          }
          if (event.key !== 'Tab') return;
          var list = Array.prototype.slice.call(
            this.drawer.querySelectorAll(
              'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
          );
          if (!list.length) return;
          if (event.shiftKey && document.activeElement === list[0]) {
            event.preventDefault();
            list[list.length - 1].focus();
          } else if (!event.shiftKey && document.activeElement === list[list.length - 1]) {
            event.preventDefault();
            list[0].focus();
          }
        }
      }
    );
  }
})()
